export const totalearning = (
  <svg
    width="32"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2281_476)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.6266 26.3734C25.0171 26.764 25.6502 26.764 26.0408 26.3734L28.7074 23.7068C29.098 23.3163 29.098 22.6831 28.7074 22.2926C28.3169 21.902 27.6837 21.902 27.2932 22.2926L26.3337 23.2521V17.6663C26.3337 17.1141 25.8859 16.6663 25.3337 16.6663C24.7814 16.6663 24.3337 17.1141 24.3337 17.6663V23.2521L23.3741 22.2926C22.9836 21.902 22.3504 21.902 21.9599 22.2926C21.5694 22.6831 21.5694 23.3163 21.9599 23.7068L24.6266 26.3734Z"
        fill="#E95923"
      />
      <path
        d="M13.3337 4.33301H18.667C23.6953 4.33301 26.2095 4.33301 27.7716 5.89511C28.8963 7.01983 29.2112 8.6381 29.2994 11.333H2.70128C2.78945 8.6381 3.10437 7.01983 4.22909 5.89511C5.79119 4.33301 8.30534 4.33301 13.3337 4.33301Z"
        fill="#E95923"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.3337 25.6663H18.667C19.5463 25.6663 20.3488 25.6663 21.0827 25.658L20.5457 25.121C19.3741 23.9494 19.3741 22.0499 20.5457 20.8784C21.0465 20.3775 21.6805 20.0907 22.3337 20.0181V17.6663C22.3337 16.0095 23.6768 14.6663 25.3337 14.6663C26.9905 14.6663 28.3337 16.0095 28.3337 17.6663V20.0181C28.6321 20.0513 28.9266 20.1292 29.2061 20.2518C29.3337 18.8892 29.3337 17.181 29.3337 14.9997C29.3337 14.4104 29.3337 13.8557 29.3311 13.333H2.66951C2.66699 13.8557 2.66699 14.4104 2.66699 14.9997C2.66699 20.028 2.66699 22.5421 4.22909 24.1042C5.79119 25.6663 8.30534 25.6663 13.3337 25.6663ZM8.00033 19.333C7.44804 19.333 7.00033 19.7807 7.00033 20.333C7.00033 20.8853 7.44804 21.333 8.00033 21.333H13.3337C13.8859 21.333 14.3337 20.8853 14.3337 20.333C14.3337 19.7807 13.8859 19.333 13.3337 19.333H8.00033ZM16.667 19.333C16.1147 19.333 15.667 19.7807 15.667 20.333C15.667 20.8853 16.1147 21.333 16.667 21.333H18.667C19.2193 21.333 19.667 20.8853 19.667 20.333C19.667 19.7807 19.2193 19.333 18.667 19.333H16.667Z"
        fill="#E95923"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2281_476"
        x="-5.33301"
        y="0.333008"
        width="42.667"
        height="38.333"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2281_476"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2281_476"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const totavehical = (
  <svg
    width="46"
    height="39"
    viewBox="0 0 46 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2281_539)">
      <path
        d="M37 13C36.179 13 35.435 12.5166 35.1013 11.7665L32.175 5.18751C32.0193 4.83347 31.7637 4.53255 31.4396 4.32162C31.1154 4.11068 30.7367 3.99892 30.35 4.00001H15.65C15.2633 3.99892 14.8846 4.11068 14.5604 4.32162C14.2363 4.53255 13.9807 4.83347 13.825 5.18751L10.8987 11.7665C10.565 12.5166 9.82098 13 9 13C8.73478 13 8.48043 13.1054 8.29289 13.2929C8.10536 13.4804 8 13.7348 8 14C8 14.2652 8.10536 14.5196 8.29289 14.7071C8.48043 14.8947 8.73478 15 9 15C9.55228 15 10 15.4477 10 16V25C10 25.5304 10.2107 26.0391 10.5858 26.4142C10.9609 26.7893 11.4696 27 12 27H15C15.5304 27 16.0391 26.7893 16.4142 26.4142C16.7893 26.0391 17 25.5304 17 25C17 23.8954 17.8954 23 19 23H27C28.1046 23 29 23.8954 29 25C29 25.5304 29.2107 26.0391 29.5858 26.4142C29.9609 26.7893 30.4696 27 31 27H34C34.5304 27 35.0391 26.7893 35.4142 26.4142C35.7893 26.0391 36 25.5304 36 25V16C36 15.4477 36.4477 15 37 15C37.2652 15 37.5196 14.8947 37.7071 14.7071C37.8946 14.5196 38 14.2652 38 14C38 13.7348 37.8946 13.4804 37.7071 13.2929C37.5196 13.1054 37.2652 13 37 13ZM17 19H15C14.7348 19 14.4804 18.8947 14.2929 18.7071C14.1054 18.5196 14 18.2652 14 18C14 17.7348 14.1054 17.4804 14.2929 17.2929C14.4804 17.1054 14.7348 17 15 17H17C17.2652 17 17.5196 17.1054 17.7071 17.2929C17.8946 17.4804 18 17.7348 18 18C18 18.2652 17.8946 18.5196 17.7071 18.7071C17.5196 18.8947 17.2652 19 17 19ZM29 19C28.7348 19 28.4804 18.8947 28.2929 18.7071C28.1054 18.5196 28 18.2652 28 18C28 17.7348 28.1054 17.4804 28.2929 17.2929C28.4804 17.1054 28.7348 17 29 17H31C31.2652 17 31.5196 17.1054 31.7071 17.2929C31.8946 17.4804 32 17.7348 32 18C32 18.2652 31.8946 18.5196 31.7071 18.7071C31.5196 18.8947 31.2652 19 31 19H29Z"
        fill="url(#paint0_linear_2281_539)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2281_539"
        x="0"
        y="0"
        width="46"
        height="39"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2281_539"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2281_539"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2281_539"
        x1="44.3"
        y1="19.18"
        x2="6.41852"
        y2="10.3704"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C06CEA" />
        <stop offset="1" stop-color="#A266F3" />
      </linearGradient>
    </defs>
  </svg>
);
export const soldvehical = (
  <svg
    width="46"
    height="39"
    viewBox="0 0 46 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2275_171)">
      <path
        d="M37 13C36.179 13 35.435 12.5166 35.1013 11.7665L32.175 5.18751C32.0193 4.83347 31.7637 4.53255 31.4396 4.32162C31.1154 4.11068 30.7367 3.99892 30.35 4.00001H15.65C15.2633 3.99892 14.8846 4.11068 14.5604 4.32162C14.2363 4.53255 13.9807 4.83347 13.825 5.18751L10.8987 11.7665C10.565 12.5166 9.82098 13 9 13C8.73478 13 8.48043 13.1054 8.29289 13.2929C8.10536 13.4804 8 13.7348 8 14C8 14.2652 8.10536 14.5196 8.29289 14.7071C8.48043 14.8947 8.73478 15 9 15C9.55228 15 10 15.4477 10 16V25C10 25.5304 10.2107 26.0391 10.5858 26.4142C10.9609 26.7893 11.4696 27 12 27H15C15.5304 27 16.0391 26.7893 16.4142 26.4142C16.7893 26.0391 17 25.5304 17 25C17 23.8954 17.8954 23 19 23H27C28.1046 23 29 23.8954 29 25C29 25.5304 29.2107 26.0391 29.5858 26.4142C29.9609 26.7893 30.4696 27 31 27H34C34.5304 27 35.0391 26.7893 35.4142 26.4142C35.7893 26.0391 36 25.5304 36 25V16C36 15.4477 36.4477 15 37 15C37.2652 15 37.5196 14.8947 37.7071 14.7071C37.8946 14.5196 38 14.2652 38 14C38 13.7348 37.8946 13.4804 37.7071 13.2929C37.5196 13.1054 37.2652 13 37 13ZM17 19H15C14.7348 19 14.4804 18.8947 14.2929 18.7071C14.1054 18.5196 14 18.2652 14 18C14 17.7348 14.1054 17.4804 14.2929 17.2929C14.4804 17.1054 14.7348 17 15 17H17C17.2652 17 17.5196 17.1054 17.7071 17.2929C17.8946 17.4804 18 17.7348 18 18C18 18.2652 17.8946 18.5196 17.7071 18.7071C17.5196 18.8947 17.2652 19 17 19ZM29 19C28.7348 19 28.4804 18.8947 28.2929 18.7071C28.1054 18.5196 28 18.2652 28 18C28 17.7348 28.1054 17.4804 28.2929 17.2929C28.4804 17.1054 28.7348 17 29 17H31C31.2652 17 31.5196 17.1054 31.7071 17.2929C31.8946 17.4804 32 17.7348 32 18C32 18.2652 31.8946 18.5196 31.7071 18.7071C31.5196 18.8947 31.2652 19 31 19H29Z"
        fill="url(#paint0_linear_2275_171)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2275_171"
        x="0"
        y="0"
        width="46"
        height="39"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2275_171"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2275_171"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2275_171"
        x1="44.3"
        y1="19.18"
        x2="6.41852"
        y2="10.3704"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#828EF1" />
        <stop offset="1" stop-color="#8684F2" />
      </linearGradient>
    </defs>
  </svg>
);
export const unsolvedvehicales = (
  <svg
    width="46"
    height="39"
    viewBox="0 0 46 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2275_272)">
      <path
        d="M37 13C36.179 13 35.435 12.5166 35.1013 11.7665L32.175 5.18751C32.0193 4.83347 31.7637 4.53255 31.4396 4.32162C31.1154 4.11068 30.7367 3.99892 30.35 4.00001H15.65C15.2633 3.99892 14.8846 4.11068 14.5604 4.32162C14.2363 4.53255 13.9807 4.83347 13.825 5.18751L10.8987 11.7665C10.565 12.5166 9.82098 13 9 13C8.73478 13 8.48043 13.1054 8.29289 13.2929C8.10536 13.4804 8 13.7348 8 14C8 14.2652 8.10536 14.5196 8.29289 14.7071C8.48043 14.8947 8.73478 15 9 15C9.55228 15 10 15.4477 10 16V25C10 25.5304 10.2107 26.0391 10.5858 26.4142C10.9609 26.7893 11.4696 27 12 27H15C15.5304 27 16.0391 26.7893 16.4142 26.4142C16.7893 26.0391 17 25.5304 17 25C17 23.8954 17.8954 23 19 23H27C28.1046 23 29 23.8954 29 25C29 25.5304 29.2107 26.0391 29.5858 26.4142C29.9609 26.7893 30.4696 27 31 27H34C34.5304 27 35.0391 26.7893 35.4142 26.4142C35.7893 26.0391 36 25.5304 36 25V16C36 15.4477 36.4477 15 37 15C37.2652 15 37.5196 14.8947 37.7071 14.7071C37.8946 14.5196 38 14.2652 38 14C38 13.7348 37.8946 13.4804 37.7071 13.2929C37.5196 13.1054 37.2652 13 37 13ZM17 19H15C14.7348 19 14.4804 18.8947 14.2929 18.7071C14.1054 18.5196 14 18.2652 14 18C14 17.7348 14.1054 17.4804 14.2929 17.2929C14.4804 17.1054 14.7348 17 15 17H17C17.2652 17 17.5196 17.1054 17.7071 17.2929C17.8946 17.4804 18 17.7348 18 18C18 18.2652 17.8946 18.5196 17.7071 18.7071C17.5196 18.8947 17.2652 19 17 19ZM29 19C28.7348 19 28.4804 18.8947 28.2929 18.7071C28.1054 18.5196 28 18.2652 28 18C28 17.7348 28.1054 17.4804 28.2929 17.2929C28.4804 17.1054 28.7348 17 29 17H31C31.2652 17 31.5196 17.1054 31.7071 17.2929C31.8946 17.4804 32 17.7348 32 18C32 18.2652 31.8946 18.5196 31.7071 18.7071C31.5196 18.8947 31.2652 19 31 19H29Z"
        fill="url(#paint0_linear_2275_272)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2275_272"
        x="0"
        y="0"
        width="46"
        height="39"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2275_272"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2275_272"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2275_272"
        x1="44.3"
        y1="19.18"
        x2="6.41852"
        y2="10.3704"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#24CFBA" />
        <stop offset="1" stop-color="#16B9DA" />
      </linearGradient>
    </defs>
  </svg>
);

export const logo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="383"
    height="80"
    viewBox="0 0 383 80"
    fill="none"
  >
    <g filter="url(#filter0_d_1541_4010)">
      <path
        d="M87 29H85C81.0469 12.2423 65.9395 0 48 0C30.0605 0 14.9531 12.2423 11 29H9C5.04693 29 2 32.0381 2 36V47C2 50.9597 5.04468 54 9 54H13C19.0173 67.0255 32.7296 76 48 76C63.2704 76 75.9827 67.0255 82 54H87C90.9531 54 94 50.9619 94 47V36C94 32.0403 90.9553 29 87 29Z"
        fill="#414042"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 30H21C24.5255 13.6136 51.7233 -7.1581 77 18C54.6076 -10.3747 20.0368 5.97431 15 30Z"
        fill="#F15A29"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M80 30H75C71.9993 16.1335 53.4002 3.68057 35 13C49.1183 1.58528 74.7856 10.2326 80 30Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 52H22C24.4294 61.8036 46.2688 80.3655 71 63C48.9937 83.1439 22.2437 69.2337 16 52Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78 50H73C68.648 63.4575 48.9883 72.3239 35 64C49.5125 75.3063 72.1423 66.1682 78 50Z"
        fill="#F15A29"
      />
      <path
        d="M29 37V32H30V37H29ZM33 37L30 35C29.9286 34.9398 30.0184 35.058 30 35C29.9816 34.942 30 34.0691 30 34C29.9735 34.0602 30 33.922 30 34C29.9164 34.0669 30.0245 33.9398 30 34L33 32H34L31 34L34 37H33Z"
        fill="white"
      />
      <path
        d="M35 37V32H36V37H35ZM39 37V35H37V34H39V32H40V37H39Z"
        fill="white"
      />
      <path
        d="M46 36.9999L45 35.9999H43V34.9999H45L43 32.9999L41 36.9999H40L43 31.9999C42.9269 32.0499 43.0542 31.9152 43 31.9999C42.8986 31.9999 43.0731 31.9499 43 31.9999C43.1014 31.9999 43.9293 31.9499 44 31.9999C43.9458 31.9152 44.0707 32.0499 44 31.9999L47 36.9999H46Z"
        fill="white"
      />
      <path d="M49 37V33H47V32H52V33H50V37H49Z" fill="white" />
      <path
        d="M36 44.0001L35 43.0001H32V42.0001H34L33 39.0001L30 44.0001H29L32 38.0001C32.0613 37.8974 32.9175 38.0594 33 38.0001C32.8845 38.0001 33.0825 37.9407 33 38.0001C32.9175 37.9407 33.1155 38.0001 33 38.0001C33.0801 38.0594 33.9387 37.8974 34 38.0001L37 44.0001H36Z"
        fill="#F15A29"
      />
      <path d="M37 44V38H38V43H42V44H37Z" fill="#F15A29" />
      <path
        d="M45 44V43H47C47.6692 43 48.7046 43.269 49 43C49.2954 42.731 49 41.5848 49 41V38H50V41C50 41.9287 49.4633 42.5532 49 43C48.5367 43.4444 48.0027 44 47 44H45Z"
        fill="#F15A29"
      />
      <path
        d="M58 44.0001L57 43.0001H54V42.0001H56L55 39.0001L52 44.0001H51L54 38.0001C54.0613 37.8974 54.9175 38.0594 55 38.0001C54.8845 38.0001 55.0825 37.9407 55 38.0001C54.9198 37.9407 55.1155 38.0001 55 38.0001C55.0802 38.0594 55.9387 37.8974 56 38.0001L59 44.0001H58Z"
        fill="#F15A29"
      />
      <path
        d="M60 44C59.8457 44 59.1135 44.0889 59 44C58.8843 43.9111 59 43.1709 59 43C58.8616 43.139 59 42.8495 59 43L63 39H59V38H64C64.1498 38 64.882 37.9111 65 38C65.118 38.0889 65 38.829 65 39C65 39.1504 65.1385 38.8609 65 39L61 43H65V44H60Z"
        fill="#F15A29"
      />
      <path d="M65 44V38H70V39H66V43H70V44H65ZM67 41H70H67Z" fill="#F15A29" />
      <path d="M71 44V38H76V39H72V43H76V44H71ZM73 41H76H73Z" fill="#F15A29" />
      <path
        d="M83 44.0001L81 42.0001H79V41.0001H81C81.3777 41.0001 81.8077 41.203 82 41.0001C82.19 40.7972 82 40.3852 82 40.0001C82 39.6151 82.1993 39.1869 82 39.0001C81.8007 38.8134 81.3592 39.0001 81 39.0001H78V44.0001H77V38.0001H81C81.3383 38.0001 81.7335 37.901 82 38.0001C82.2665 38.1016 82.8146 38.8134 83 39.0001C82.9004 38.735 83.1854 39.1869 83 39.0001C83.0973 39.2653 83 39.6704 83 40.0001C83 40.4935 83.2155 40.6658 83 41.0001C82.7845 41.3344 82.3893 41.8549 82 42.0001L84 44.0001H83Z"
        fill="#F15A29"
      />
      <path
        d="M91 44.0001L90 43.0001H87V42.0001H89L88 39.0001L85 44.0001H84L87 38.0001C87.0613 37.8974 87.9175 38.0594 88 38.0001C87.8845 38.0001 88.0825 37.9407 88 38.0001C87.9175 37.9407 88.1155 38.0001 88 38.0001C88.0801 38.0594 88.9387 37.8974 89 38.0001L92 44.0001H91Z"
        fill="#F15A29"
      />
      <path
        d="M39 47.9999C38.8016 47.9999 39.1664 48.0741 39 47.9999C38.8317 47.9258 38.1243 48.1282 38 47.9999C37.8757 47.8717 38.0682 47.1763 38 46.9999C37.9319 46.8236 38 46.2044 38 45.9999C37.9299 46.1703 38 45.7955 38 45.9999C38.0682 45.8296 37.8757 45.1202 38 44.9999C38.1243 44.8797 38.8317 45.0661 39 44.9999C38.8036 44.9999 39.1684 44.9338 39 44.9999H41V45.9999H39C38.8717 45.9999 39.1082 45.9538 39 45.9999C38.8918 46.046 39.0782 45.9198 39 45.9999C38.9218 46.0801 39.0441 45.8877 39 45.9999C38.9559 46.1122 39 45.8657 39 45.9999C39 46.1342 38.9559 46.8877 39 46.9999C38.9238 46.9178 39.0441 47.1142 39 46.9999C38.8918 46.9538 39.0782 47.0821 39 46.9999C38.8737 46.9999 39.1082 47.046 39 46.9999H41V47.9999H39Z"
        fill="white"
      />
      <path
        d="M44 48V47H42H43H44L43 46L42 48H41L43 45C42.9572 45.029 43.03 44.9481 43 45C42.9422 45 43.0428 44.9709 43 45C42.9593 44.9709 43.0578 45 43 45C42.9679 44.9502 43.0407 45.029 43 45L45 48H44Z"
        fill="white"
      />
      <path
        d="M49 48L48 47H47H48C48.2138 47 48.8931 47.1019 49 47C49.1069 46.8981 49 46.1912 49 46C49 45.8088 49.1117 46.0935 49 46C48.8883 45.9065 48.2043 46 48 46H47V48H46V45H48C48.1901 45 48.8479 44.9501 49 45C48.8955 44.9065 49.1497 45.0499 49 45C49.1045 45.0935 49.9454 45.869 50 46C50 45.8358 50.0546 46.131 50 46C50 46.2453 49.1212 46.8337 49 47C48.8788 47.1663 49.2186 46.9272 49 47L50 48H49Z"
        fill="white"
      />
      <path
        d="M50 48.0001V47.0001H52C51.9335 47.0678 52.122 47.0001 52 47.0001C52.0665 46.9323 53 47.1151 53 47.0001C53 46.8748 52.0665 47.0637 52 47.0001C51.9335 46.9385 52.122 47.0001 52 47.0001H51C50.8781 47.0001 50.0998 47.0411 50 47.0001C49.9003 46.959 50.0684 46.0719 50 46.0001C49.9317 45.9262 50.037 46.1007 50 46.0001C49.9631 45.8995 50 46.1192 50 46.0001C49.9649 46.0986 50 45.881 50 46.0001C50.0351 45.8995 49.9317 45.0719 50 45.0001C49.9003 45.0432 50.0684 44.9282 50 45.0001C50.0998 44.959 50.8707 45.0001 51 45.0001H53V46.0001H51C50.8947 46.0001 51.0573 45.9364 51 46.0001C50.9428 46.0617 51 45.8892 51 46.0001C50.9409 45.9385 51 46.1109 51 46.0001C50.9003 46.0001 51.0592 46.0617 51 46.0001H52C52.2661 46.0001 52.8615 45.8625 53 46.0001C53.1386 46.1376 53 46.7188 53 47.0001C53 47.1233 53.0333 46.8974 53 47.0001C52.9668 47.1027 53.0684 47.9241 53 48.0001C52.9335 48.076 53.1017 47.959 53 48.0001C52.8984 48.0432 52.1368 48.0001 52 48.0001H50Z"
        fill="white"
      />
      <path
        d="M58 48V47H56H57H58L57 46L56 48H55L57 45C56.9572 45.029 57.03 44.9481 57 45C56.9422 45 57.0407 44.9709 57 45C56.9593 44.9709 57.0578 45 57 45C56.9679 44.9502 57.0407 45.029 57 45L59 48H58Z"
        fill="white"
      />
      <path
        d="M62 45V47C62 47.2228 62.0539 46.8365 62 47C61.9461 47.1656 62.1135 47.8917 62 48C61.8866 48.1083 61.1785 47.9489 61 48C60.8215 48.0511 60.2548 48 60 48C59.7452 48 60.1785 48.0531 60 48C59.8196 47.9469 59.1135 48.1083 59 48C58.8866 47.8917 59.0521 47.1656 59 47C58.9479 46.8344 59 47.2207 59 47V45H60V47C59.9684 46.8958 60 47.1451 60 47C59.9256 46.9346 60.0335 47.1022 60 47C59.8754 46.9693 60.0744 47.0654 60 47C60.1228 47.0307 60.8196 47 61 47C60.8773 47.0307 61.1804 47 61 47C60.9256 47.0674 61.1228 46.9693 61 47C60.9665 47.1022 61.0744 46.9346 61 47C61.0335 46.8958 62 47.1472 62 47V45Z"
        fill="white"
      />
      <path
        d="M64 47.9999C63.8016 47.9999 64.1664 48.0741 64 47.9999C63.8317 47.9258 63.1243 48.1282 63 47.9999C62.8757 47.8717 63.0682 47.1763 63 46.9999C62.9319 46.8236 63 46.2044 63 45.9999C62.9299 46.1703 63 45.7955 63 45.9999C63.0682 45.8296 62.8757 45.1202 63 44.9999C63.1243 44.8797 63.8317 45.0661 64 44.9999C63.8036 44.9999 64.1684 44.9338 64 44.9999H66V45.9999H64C63.8717 45.9999 64.1082 45.9538 64 45.9999C63.8918 46.046 64.0782 45.9198 64 45.9999C63.9218 46.0801 64.0441 45.8877 64 45.9999C63.9559 46.1122 64 45.8657 64 45.9999C64 46.1342 63.9559 46.8877 64 46.9999C63.9238 46.9178 64.0441 47.1142 64 46.9999C63.8918 46.9538 64.0782 47.0821 64 46.9999C63.8737 46.9999 64.1082 47.046 64 46.9999H66V47.9999H64Z"
        fill="white"
      />
      <path d="M67 48V46H66V45H69V46H68V48H67Z" fill="white" />
      <path d="M70 48V45H71V48H70Z" fill="white" />
      <path
        d="M72 48C71.7812 48 71.1835 48.0742 71 48C70.8143 47.9259 70.1371 48.1283 70 48C69.863 47.8717 70.0752 47.1764 70 47C69.9249 46.8236 70 46.2045 70 46C69.9227 46.1704 70 45.7956 70 46C70.0752 45.8297 69.863 45.1203 70 45C70.1371 44.8798 70.8143 45.0662 71 45C71.1857 44.9339 71.7834 45 72 45C72.2255 45 72.8121 44.9319 73 45C73.1879 45.0682 73.8652 44.8778 74 45C74.1349 45.1223 73.9249 45.8317 74 46C74 45.7936 74.0752 46.1704 74 46C74 46.2065 74.0774 46.8236 74 47C73.9249 47.1764 74.1371 47.8717 74 48C73.863 48.1283 73.1857 47.9279 73 48C72.8143 48.0742 72.2233 48 72 48ZM72 47C72.1437 47 72.8784 47.0461 73 47C72.9138 47.0822 73.1216 46.9539 73 47C72.9514 47.1143 73.0884 46.9178 73 47C73.0487 46.8858 73 46.1323 73 46C73 45.8677 73.0487 46.1123 73 46C72.9514 45.8878 73.0862 46.0822 73 46C72.9116 45.9198 73.1194 46.0461 73 46C72.8807 45.9539 72.1437 46 72 46C71.8586 46 71.1194 45.9539 71 46C70.8807 46.0461 71.0862 45.9198 71 46C70.9138 46.0802 71.0487 45.8878 71 46C70.9514 46.1123 71 45.8657 71 46C71 46.1343 70.9514 46.8878 71 47C70.916 46.9178 71.0487 47.1143 71 47C70.8807 46.9539 71.0862 47.0822 71 47C71.1194 47.0461 71.8608 47 72 47Z"
        fill="white"
      />
      <path
        d="M74.9999 45.9999V47.9999V44.9999C74.9544 45.0536 74.9999 44.9105 74.9999 44.9999C74.9247 44.9999 75.0455 44.9482 74.9999 44.9999C74.9663 44.984 75.0356 44.9999 74.9999 44.9999C74.9623 44.9641 75.0336 45.0158 74.9999 44.9999L77.9999 46.9999V44.9999V47.9999C77.9999 48.0933 78.0455 47.9482 77.9999 47.9999C77.9544 48.0516 78.0732 47.9999 77.9999 47.9999C77.9208 47.9999 78.0692 48.0695 77.9999 47.9999L74.9999 45.9999Z"
        fill="white"
      />
      <path
        d="M79 48.0001V47.0001H81C80.9335 47.0678 81.122 47.0001 81 47.0001C81.0665 46.9323 82 47.1151 82 47.0001C82 46.8748 81.0665 47.0637 81 47.0001C80.9335 46.9385 81.122 47.0001 81 47.0001H80C79.8781 47.0001 79.0998 47.0411 79 47.0001C78.9003 46.959 79.0684 46.0719 79 46.0001C78.9317 45.9262 79.037 46.1007 79 46.0001C78.9631 45.8995 79 46.1192 79 46.0001C78.9649 46.0986 79 45.881 79 46.0001C79.0351 45.9015 78.9317 45.0719 79 45.0001C78.9003 45.0432 79.0684 44.9282 79 45.0001C79.1017 44.959 79.8707 45.0001 80 45.0001H82V46.0001H80C79.8947 46.0001 80.0573 45.9364 80 46.0001C79.9428 46.0617 80 45.8892 80 46.0001C79.9409 45.9385 80 46.1109 80 46.0001C79.9003 46.0001 80.0592 46.0617 80 46.0001H81C81.2661 46.0001 81.8615 45.8625 82 46.0001C82.1386 46.1376 82 46.7188 82 47.0001C82 47.1233 82.0333 46.8974 82 47.0001C81.9668 47.1027 82.0684 47.9241 82 48.0001C81.9317 48.076 82.1017 47.959 82 48.0001C81.8984 48.0432 81.1368 48.0001 81 48.0001H79Z"
        fill="white"
      />
      <path d="M49 26H40V27H49V26Z" fill="#F15A29" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40 27L38 29H52L50 27H40Z"
        fill="#F15A29"
      />
      <path
        d="M43 22.9999C43.1002 22.9139 43.2367 22.344 43 21.9999L42 20.9999C41.7633 20.6558 41.2021 19.2948 41 18.9999C40.7979 18.705 39.9017 18.6435 40 18.9999C40.0983 19.3563 40.8907 20.5821 41 20.9999C41.1093 21.4177 40.3624 22.1228 40 21.9999C39.6394 21.877 39.2021 21.0716 39 20.9999C38.7979 20.9282 38.8634 21.8197 39 21.9999C39.1366 22.1801 39.7487 22.6681 40 22.9999C40.2513 23.3317 40.2968 23.7705 40 23.9999C39.7032 24.2293 39.1512 24.8832 39 24.9999C38.8197 24.9938 38.8489 25.1166 39 24.9999C39.1803 25.004 39.614 24.9815 40 24.9999H42C42.3879 25.0183 42.9945 25.1351 43 24.9999C43.0055 24.8647 42.3861 24.0204 42 23.9999H41C40.614 23.9794 40.7961 24.1515 41 23.9999C40.9454 24.0429 41.204 23.8483 41 23.9999C41.0546 23.9569 41.0437 23.0572 41 22.9999C40.9563 22.9426 41.204 23.2661 41 22.9999C40.7961 22.7337 40.7287 21.9077 41 21.9999C41.2713 22.0921 41.8926 22.9651 42 22.9999C42.0346 23.1228 42.1075 23.0347 42 22.9999C41.9654 22.877 42.0601 22.2334 42 21.9999C41.7651 21.6538 41.9399 21.7685 42 21.9999C42.2349 22.346 42.9017 23.0859 43 22.9999Z"
        fill="#F15A29"
      />
      <path
        d="M52 15C52 15 53.1307 15.4936 54 17C54 17 55.2269 18.0444 54 19C54 19 54.8439 19.5219 55 18C55 18 54.3612 15.7477 53 15C53 15 51.138 14.0155 50 14C50 14 48.4073 14.2812 49 16C49 16 49.1925 13.8187 52 15Z"
        fill="#F15A29"
      />
      <path
        d="M53 18C53 18 53.219 16.4818 52 16C52 16 50.7047 15.4864 50 16C50 16 52.3518 16.924 53 18Z"
        fill="#F15A29"
      />
      <path
        d="M47 18C47.6739 17.0989 48 16 48 16C47.3604 16.384 46 19 46 19C46 19 46.3207 18.9055 47 18Z"
        fill="#F15A29"
      />
      <path
        d="M52 20C51.3874 20.7798 51 22 51 22C51 22 53.5209 20.1916 54 19C54 19 52.6073 19.2142 52 20Z"
        fill="#F15A29"
      />
      <path
        d="M65 29C62.9152 26.5381 53 21 53 21C54.9481 23.3576 65 29 65 29Z"
        fill="#F15A29"
      />
      <path
        d="M59 26C56.8841 23.7069 52 22 52 22C54.5824 24.2719 59 26 59 26Z"
        fill="#F15A29"
      />
      <path
        d="M49 21.0001C47.3815 19.5305 45 20.0001 45 20.0001C46.9337 20.5298 47.8666 20.9012 48 21.0001C48.584 21.4268 48.5009 22.1859 49 23.0001C49.4183 23.6741 49.6466 24.6518 49 25.0001C47.5027 25.7936 46.4124 25.3711 45 25.0001C46.2993 26.3769 48.4019 26.4412 49 26.0001C50.4649 24.9221 50 23.0001 50 23.0001C49.7252 22.3117 49 21.0001 49 21.0001Z"
        fill="#F15A29"
      />
      <path
        d="M47 25C47 25 46.6164 24.3043 46 24C45.7308 23.837 45.0926 23.4869 45 23C45 23 44.3593 20.9666 46 21C46 21 44.5743 20.2579 44 21C43.7918 21.265 43.7602 22.3227 44 23C44.061 23.161 44.8733 24.7291 47 25Z"
        fill="#F15A29"
      />
      <path
        d="M8 46C8 46.5512 9.17168 47 10 47C10.8283 47 11 46.5512 11 46C11 45.4488 10.8283 45 10 45C9.17168 45 8 45.4488 8 46Z"
        fill="white"
      />
      <path
        d="M15 41.9999C15.4847 41.1238 15 40.9999 15 40.9999L10 38.9999C8.56674 38.5041 8 39.9999 8 39.9999V42.9999H14L15 41.9999ZM10 39.9999H9C8.98964 39.8163 9 39.9999 9 39.9999C9.01036 40.1834 9 40.9999 9 40.9999C9 40.9999 9.18019 40.9829 9 40.9999C9 40.9999 9.01864 41.1834 9 40.9999V39.9999C8.58369 39.9999 9 39.9999 9 39.9999H10C10.0062 39.8296 10 39.9999 10 39.9999C10 39.9999 9.98964 40.1702 10 39.9999Z"
        fill="white"
      />
      <path
        d="M11 49.0001H7.99999C7.99999 49.0001 6.99999 48.5844 6.99999 47.0001V42.0001C6.99999 42.0001 6.68176 40.03 7.99999 39.0001C7.99999 39.0001 9.09713 36.8971 11 37.0001H25L12 36.0001C12 36.0001 10.8962 36.0366 12 35.0001L14 34.0001C14 34.0001 14.754 32.908 17 33.0001L27 32.0001H16C16 32.0001 14.0925 31.7619 13 33.0001L9.99999 36.0001C9.99999 36.0001 8.9413 35.87 8.99999 35.0001C8.99999 35.0001 9.08347 34.4142 7.99999 34.0001C7.99999 34.0001 6.84871 33.0687 5.99999 34.0001C5.99999 34.0001 4.49666 35.6582 5.99999 36.0001H6.99999C6.99999 36.0001 9.10604 36.3164 7.99999 37.0001C7.99999 37.0001 4.9097 38.1118 4.99999 41.0001L5.99999 49.0001C5.99999 49.0001 5.67051 51.182 7.99999 51.0001H12C12 51.0001 14.0361 51.0753 14 49.0001H26V48.0001H13C13 48.0001 12.2798 49.0001 11 49.0001Z"
        fill="white"
      />
      <path d="M14 46V47L25 46H14Z" fill="white" />
      <path d="M24 45H14V46L24 45Z" fill="white" />
      <path
        d="M15 48H25L15 47C14.0378 47.0911 14 47 14 47V45L24 44H13V47C13.0281 48.0351 15 48 15 48Z"
        fill="white"
      />
      <path d="M23 42L15 41L14 43H23L15 42H23H15H16H23Z" fill="white" />
    </g>
    <g filter="url(#filter1_d_1541_4010)">
      <path
        d="M275 53.8784C273.37 53.8784 272 52.6191 272 50.8784C272 49.1378 273.37 47.8784 275 47.8784H278V48.8784H275C273.956 48.8784 273 49.7398 273 50.8784C273 52.017 273.949 52.8784 275 52.8784H278V53.8784H275Z"
        fill="white"
      />
      <path
        d="M285 53.9225L284 52.9225H281V51.9225H283L282 48.9225L279 53.9225H278L281 47.9225C281.126 47.7244 281.766 47.9225 282 47.9225C282.234 47.9225 282.874 47.7244 283 47.9225L286 53.9225H285Z"
        fill="white"
      />
      <path
        d="M293 53.9004L291 51.9004H289V50.9004H291C291.745 50.9004 292 50.675 292 49.9004C292 49.1258 291.711 48.9004 291 48.9004H288V53.9004H287V47.9004H291C292.359 47.9004 293 48.5634 293 49.9004C293 50.8906 292.768 51.6037 292 51.9004L294 53.9004H293Z"
        fill="white"
      />
      <path
        d="M294 53.9004V52.9004H299C299.61 52.9004 300 52.3695 300 51.9004C300 51.3882 299.608 50.9004 299 50.9004H296C294.773 50.9004 294 50.8903 294 49.9004C294 48.9105 294.701 47.9004 296 47.9004H301V48.9004H296C295.48 48.9004 295 49.4451 295 49.9004C295 50.3557 295.499 50.9004 296 50.9004H299C300.316 50.9004 301 50.7363 301 51.9004C301 52.9076 300.36 53.9004 299 53.9004H294Z"
        fill="white"
      />
      <path
        d="M310 53.9335L309 52.9335H306V51.9335H308L307 48.9335L304 53.9335H303L306 47.9335C306.126 47.7354 306.766 47.9335 307 47.9335C307.234 47.9335 307.874 47.7354 308 47.9335L311 53.9335H310Z"
        fill="white"
      />
      <path
        d="M317 47.9058H318V50.9058C318 52.7367 316.514 53.9058 314 53.9058C311.486 53.9058 311 52.7367 311 50.9058V47.9058H312V50.9058C312 52.0935 313.217 52.9058 315 52.9058C316.783 52.9058 317 52.0935 317 50.9058V47.9058Z"
        fill="white"
      />
      <path
        d="M321 53.9058C319.37 53.9058 318 52.6464 318 50.9058C318 49.1651 319.37 47.9058 321 47.9058H324V48.9058H321C319.956 48.9058 319 49.7672 319 50.9058C319 52.0443 319.949 52.9058 321 52.9058H324V53.9058H321Z"
        fill="white"
      />
      <path
        d="M327 53.9058V48.9058H325V47.9058H331V48.9058H329V53.9058H327Z"
        fill="white"
      />
      <path d="M331 53.9058V47.9058H332V53.9058H331Z" fill="white" />
      <path
        d="M336 53.9058C334.396 53.9058 333 52.6464 333 50.9058C333 49.1651 334.396 47.9058 336 47.9058H337C338.659 47.9058 340 49.1651 340 50.9058C340 52.6464 338.636 53.9058 337 53.9058H336ZM337 52.9058C338.059 52.9058 339 52.0357 339 50.9058C339 49.7758 338.057 48.9058 337 48.9058H336C334.973 48.9058 334 49.7672 334 50.9058C334 52.0443 334.966 52.9058 336 52.9058H337Z"
        fill="white"
      />
      <path
        d="M342 49.9556V53.9556H341V48.9556C341 48.5929 341.68 47.9556 342 47.9556C341.848 47.8089 342.151 47.9556 342 47.9556L346 51.9556V47.9556H347V52.9556C347 53.3247 346.295 53.9556 346 53.9556C345.832 53.9556 346.144 54.0942 346 53.9556L342 49.9556Z"
        fill="white"
      />
      <path
        d="M348 53.9478V52.9478H353C353.61 52.9478 354 52.4169 354 51.9478C354 51.4355 353.608 50.9478 353 50.9478H350C348.773 50.9478 348 50.9377 348 49.9478C348 48.9578 348.701 47.9478 350 47.9478H355V48.9478H350C349.48 48.9478 349 49.4925 349 49.9478C349 50.4031 349.499 50.9478 350 50.9478H353C354.316 50.9478 355 50.7836 355 51.9478C355 52.9549 354.36 53.9478 353 53.9478H348Z"
        fill="white"
      />
      <path
        d="M358 53.9478V47.9478H359V52.9478H363V53.9478H358Z"
        fill="white"
      />
      <path
        d="M366 53.9478V47.9478H367V52.9478H371V53.9478H366Z"
        fill="white"
      />
      <path
        d="M377 53.9478C375.37 53.9478 374 52.6884 374 50.9478C374 49.2071 375.37 47.9478 377 47.9478H380V48.9478H377C375.956 48.9478 375 49.8092 375 50.9478C375 52.0863 375.949 52.9478 377 52.9478H380V53.9478H377Z"
        fill="white"
      />
      <path
        d="M121 30.9477V31.9477V33.9477C121 35.1888 119.53 35.9477 117 35.9477H113C112.168 35.9477 112 36.4185 112 36.9477V37.9477L110 36.9477V35.9477C110 35.0461 111.455 34.9477 113 34.9477H115C114.66 34.5874 114 34.339 114 33.9477C114 33.1633 114.253 32.4252 115 31.9477C115.747 31.4702 117.692 30.9477 119 30.9477C119.814 30.9477 120.202 30.7891 121 30.9477ZM119 31.9477C118.729 31.8942 118.323 31.9477 118 31.9477C116.573 31.9477 116 31.8358 116 32.9477C116 33.8389 117.033 34.9477 118 34.9477C119.205 34.9477 119 33.8906 119 32.9477C119 32.7046 119.084 32.2976 119 31.9477Z"
        fill="white"
      />
      <path
        d="M135 30.9477V31.9477V33.9477C135 35.1888 133.53 35.9477 131 35.9477H127C126.168 35.9477 126 36.4185 126 36.9477V37.9477L124 36.9477V35.9477C124 35.0461 125.455 34.9477 127 34.9477H129C128.66 34.5874 128 34.339 128 33.9477C128 33.1633 128.253 32.4252 129 31.9477C129.747 31.4702 131.692 30.9477 133 30.9477C133.814 30.9477 134.202 30.7891 135 30.9477ZM133 31.9477C132.729 31.8942 132.323 31.9477 132 31.9477C130.573 31.9477 130 31.8358 130 32.9477C130 33.8389 131.033 34.9477 132 34.9477C133.205 34.9477 133 33.8906 133 32.9477C133 32.7046 133.084 32.2976 133 31.9477Z"
        fill="white"
      />
      <path
        d="M144 33.9478V34.9478V35.9478H137V34.9478H142V33.9478C142 33.4157 141.336 32.2624 141 31.9478C140.683 31.6755 140.512 31.9478 140 31.9478C139.841 31.9478 140.194 31.893 140 31.9478C140 31.8399 140.053 31.2412 140 30.9478C139.7 30.9813 140.053 30.9478 140 30.9478C141.076 30.9478 142.347 31.4793 143 31.9478C143.653 32.4038 143.983 33.2407 144 33.9478ZM141 29.9478C141 30.3066 140.617 29.9478 140 29.9478C139.383 29.9478 139 30.3278 139 29.9478C139 29.5677 139.383 28.9478 140 28.9478C140.564 28.9478 141 29.5677 141 29.9478Z"
        fill="white"
      />
      <path
        d="M160 34.9478C160 36.0859 159.509 36.9478 158 36.9478H150C149.056 36.9478 148.565 36.4355 148 35.9478C147.435 35.4478 147 34.7607 147 33.9478C147 33.3238 147.569 33.5107 148 32.9478H149C148.485 33.4985 148 33.4844 148 33.9478C148 35.1591 148.692 35.9478 150 35.9478H157C157.813 35.9478 158 35.6103 158 34.9478V33.9478V31.9478H160V34.9478ZM153 31.9478C153 32.3603 152.547 32.9478 152 32.9478C151.419 32.9478 151 32.3969 151 31.9478C151 31.5352 151.419 30.9478 152 30.9478C152.547 30.9478 153 31.5108 153 31.9478ZM156 31.9478C156 32.3603 155.547 32.9478 155 32.9478C154.419 32.9478 154 32.3969 154 31.9478C154 31.5352 154.419 30.9478 155 30.9478C155.547 30.9478 156 31.5108 156 31.9478Z"
        fill="white"
      />
      <path
        d="M163 28.9478V29.9478V35.9478H161V29.9478V28.9478H163Z"
        fill="white"
      />
      <path
        d="M168 35.9478C168 37.4145 166.425 38.513 164 38.9478C165.559 38.6332 166 37.0346 166 35.9478V33.9478V31.9478H168V35.9478Z"
        fill="white"
      />
      <path
        d="M173 35.9478H172C170.502 35.9478 169 34.9571 169 33.9478V30.9478V28.9478H171V33.9478C171 34.5452 171.21 34.9478 172 34.9478H173V35.9478Z"
        fill="white"
      />
      <path
        d="M174 37.9478C174 38.2833 173.534 38.9478 173 38.9478C172.511 38.9478 172 38.336 172 37.9478C172 37.5911 172.511 37.9478 173 37.9478C173.489 37.9478 174 37.57 174 37.9478ZM178 36.9478H177C176.389 36.9478 175.381 36.1639 175 35.9478C174.603 36.1639 174.58 36.9478 174 36.9478H172V35.9478H173C173.748 35.9478 175 35.5205 175 34.9478V33.9478L174 31.9478H176V34.9478C176 35.5205 176.252 35.9478 177 35.9478H178V36.9478ZM176 37.9478C176 38.2833 175.534 38.9478 175 38.9478C174.497 38.9478 174 38.336 174 37.9478C174 37.5911 174.497 37.9478 175 37.9478C175.503 37.9478 176 37.57 176 37.9478Z"
        fill="white"
      />
      <path
        d="M192 36.9478H191C190.363 36.9478 190.429 37.1723 190 36.9478C189.603 37.1723 188.605 36.9478 188 36.9478C187.157 36.9478 186.589 36.3749 186 35.9478C185.571 36.3749 184.859 36.9478 184 36.9478C183.189 36.9478 182.62 36.3859 182 35.9478C181.92 36.0263 182.111 36.8693 182 36.9478C181.571 37.2289 180.716 36.9478 180 36.9478H178V35.9478H179C179.763 35.9478 181 35.5429 181 34.9478V32.9478L182 31.9478V35.9478C182.397 36.2052 183.474 35.9478 184 35.9478C184.748 35.9478 185 35.5429 185 34.9478V32.9478L186 31.9478V35.9478C186.397 36.2289 187.475 35.9478 188 35.9478C188.748 35.9478 189 35.5429 189 34.9478V33.9478L188 31.9478H190V34.9478C190 35.5319 191.237 35.9478 192 35.9478V36.9478Z"
        fill="white"
      />
      <path
        d="M198 33.9478C198 34.9495 196.644 35.9478 195 35.9478H192V34.9478H195C195.875 34.9478 196 34.5397 196 33.9478V30.9478V28.9478H198V33.9478Z"
        fill="white"
      />
      <path
        d="M201 28.9478V29.9478V35.9478H199V29.9478V28.9478H201Z"
        fill="white"
      />
      <path
        d="M211 34.9478V35.9478V36.9478H204V35.9478H209V33.9478C209 33.3692 208.336 33.2899 208 32.9478C207.683 32.6517 207.512 32.9478 207 32.9478C206.841 32.9478 207.194 32.8882 207 32.9478C207 32.8305 207.053 32.2668 207 31.9478C206.7 31.9843 207.053 31.9478 207 31.9478C208.076 31.9478 209.347 32.4384 210 32.9478C210.653 33.4437 210.983 34.1788 211 34.9478Z"
        fill="white"
      />
      <path
        d="M215 28.9478V29.9478V35.9478H213V29.9478V28.9478H215Z"
        fill="white"
      />
      <path
        d="M221 35.9478H220C219.704 35.9478 219.246 36.006 219 35.9478C218.803 37.2882 217.154 38.5323 215 38.9478C216.512 38.6131 217 37.1039 217 35.9478V32.9478V31.9478H219V33.9478C219 34.5832 219.194 34.9478 220 34.9478H221V35.9478ZM219 29.9478C219 30.3294 218.576 29.9478 218 29.9478C217.458 29.9478 217 30.3519 217 29.9478C217 29.5436 217.458 28.9478 218 28.9478C218.542 28.9478 219 29.5436 219 29.9478Z"
        fill="white"
      />
      <path
        d="M231 35.9478H230C229.374 35.9478 228.44 36.1799 228 35.9478C227.171 36.5853 226.165 36.9478 225 36.9478C224.054 36.9478 223.488 36.4853 223 35.9478C222.629 36.0799 222.472 35.9478 222 35.9478H220V34.9478H221C221.76 34.9478 221.984 35.4317 222 34.9478C222.085 33.3762 224.431 31.9478 227 31.9478C227.829 31.9478 228.189 31.7835 229 31.9478V32.9478V33.9478C229 34.53 229.171 34.9478 230 34.9478H231V35.9478ZM227 35.9478V32.9478C226.747 32.8924 226.286 32.9478 226 32.9478C224.598 32.9478 224 33.7941 224 34.9478C224 35.8711 225.188 35.9478 226 35.9478C226.608 35.9478 226.51 36.2782 227 35.9478Z"
        fill="white"
      />
      <path
        d="M237 33.9478C237 34.9495 235.644 35.9478 234 35.9478H231V34.9478H234C234.875 34.9478 235 34.5397 235 33.9478V30.9478V28.9478H237V33.9478Z"
        fill="white"
      />
      <path
        d="M110 53.9478V42.9478H112V53.9478H110ZM118 53.9478L113 48.9478C112.695 48.6911 112 48.2487 112 47.9478C112 47.6154 112.638 47.2506 113 46.9478L118 42.9478H121L114 47.9478L121 53.9478H118Z"
        fill="url(#paint0_linear_1541_4010)"
      />
      <path
        d="M122 53.9478V42.9478H124V53.9478H122ZM130 53.9478V48.9478H125V47.9478H130V42.9478H132V53.9478H130Z"
        fill="url(#paint1_linear_1541_4010)"
      />
      <path
        d="M145 53.9478L143 50.9478H138L139 49.9478H142L140 45.9478L135 53.9478H133L139 43.9478C139.219 43.5743 139.593 42.9478 140 42.9478C140.407 42.9478 140.781 43.5743 141 43.9478L147 53.9478H145Z"
        fill="url(#paint2_linear_1541_4010)"
      />
      <path
        d="M149 53.9478V44.9478H145V42.9478H155V44.9478H151V53.9478H149Z"
        fill="url(#paint3_linear_1541_4010)"
      />
      <path
        d="M171 53.9478L169 50.9478H164L165 49.9478H168L166 45.9478L161 53.9478H159L165 43.9478C165.219 43.5743 165.591 42.9478 166 42.9478C166.409 42.9478 166.781 43.5743 167 43.9478L173 53.9478H171Z"
        fill="url(#paint4_linear_1541_4010)"
      />
      <path
        d="M174 53.9478V42.9478H176V51.9478H183V53.9478H174Z"
        fill="url(#paint5_linear_1541_4010)"
      />
      <path
        d="M187 53.9478V51.9478H191C193.422 51.9478 194 51.0805 194 48.9478V42.9478H196V48.9478C196 52.351 194.602 53.9478 191 53.9478H187Z"
        fill="url(#paint6_linear_1541_4010)"
      />
      <path
        d="M207 53.9478L205 50.9478H200L201 49.9478H204L202 45.9478L197 53.9478H195L201 43.9478C201.219 43.5743 201.593 42.9478 202 42.9478C202.407 42.9478 202.781 43.5743 203 43.9478L209 53.9478H207Z"
        fill="url(#paint7_linear_1541_4010)"
      />
      <path
        d="M211 53.9478C210.492 53.9478 210 53.5997 210 52.9478C210 52.6615 209.774 52.2045 210 51.9478L217 44.9478H210V42.9478H219C219.495 42.9478 220 43.2958 220 43.9478C220 44.234 220.228 44.691 220 44.9478L213 51.9478H220V53.9478H211Z"
        fill="url(#paint8_linear_1541_4010)"
      />
      <path
        d="M221 53.9478V42.9478H230V44.9478H223V51.9478H230V53.9478H221ZM224 48.9478V47.9478H230V48.9478H224Z"
        fill="url(#paint9_linear_1541_4010)"
      />
      <path
        d="M232 53.9478V42.9478H241V44.9478H234V51.9478H241V53.9478H232ZM235 48.9478V47.9478H241V48.9478H235Z"
        fill="url(#paint10_linear_1541_4010)"
      />
      <path
        d="M251 53.9478L249 50.9478H245V48.9478H249C250.279 48.9478 251 48.3696 251 46.9478C251 45.5259 250.221 44.9478 249 44.9478H244V53.9478H242V42.9478H249C251.331 42.9478 253 44.4974 253 46.9478C253 48.7629 252.32 50.403 251 50.9478L254 53.9478H251Z"
        fill="url(#paint11_linear_1541_4010)"
      />
      <path
        d="M266 53.9478L264 50.9478H259L260 49.9478H263L261 45.9478L256 53.9478H254L260 43.9478C260.219 43.5743 260.591 42.9478 261 42.9478C261.409 42.9478 261.781 43.5743 262 43.9478L268 53.9478H266Z"
        fill="url(#paint12_linear_1541_4010)"
      />
      <path
        d="M255 30.9824C255 32.4598 254.29 34.0476 253 34.9824C251.708 35.8961 250.151 35.9824 248 35.9824C245.849 35.9824 244.258 35.8519 243 34.9824C241.776 34.0917 241 32.4386 241 30.9824C241 29.5262 241.742 28.9173 243 27.9824C244.258 27.0476 245.718 25.9824 248 25.9824C252.236 25.9824 255 27.8739 255 30.9824ZM248 22.9824C248 23.6999 247.159 24.9824 246 24.9824C244.941 24.9824 243 23.7653 243 22.9824C243 22.2649 244.942 21.9824 246 21.9824C247.058 21.9824 248 22.2225 248 22.9824ZM251 30.9824C251 28.678 250.25 27.9824 248 27.9824C245.617 27.9824 245 28.678 245 30.9824C245 33.2869 245.716 34.9824 248 34.9824C250.284 34.9824 251 33.3081 251 30.9824ZM253 22.9824C253 23.6999 252.157 24.9824 251 24.9824C249.909 24.9824 249 23.7653 249 22.9824C249 22.2649 249.909 21.9824 251 21.9824C252.091 21.9824 253 22.2225 253 22.9824Z"
        fill="url(#paint13_linear_1541_4010)"
      />
      <path
        d="M267 35.9824H264C263.41 35.9824 263.492 36.0902 263 35.9824C262.607 38.5046 260.296 40.2012 256 40.9824L255 39.9824C258.049 39.3514 260 38.1564 260 35.9824V29.9824L259 27.9824L263 26.9824V31.9824C263 33.1772 263.392 33.9824 265 33.9824H267V35.9824Z"
        fill="url(#paint14_linear_1541_4010)"
      />
      <path
        d="M270 39.9824C270 40.6568 269.13 40.9824 268 40.9824C266.967 40.9824 266 40.7648 266 39.9824C266 39.2638 266.969 37.9824 268 37.9824C269.031 37.9824 270 39.2195 270 39.9824ZM276 32.9824C276 34.9207 273.936 35.9824 271 35.9824H266V33.9824H270C271.58 33.9824 273 34.1365 273 32.9824V29.9824L272 27.9824L276 26.9824V32.9824ZM275 39.9824C275 40.6568 274.128 40.9824 273 40.9824C271.936 40.9824 271 40.7648 271 39.9824C271 39.2638 271.936 37.9824 273 37.9824C274.064 37.9824 275 39.2195 275 39.9824Z"
        fill="url(#paint15_linear_1541_4010)"
      />
      <path
        d="M289 35.9824H286C285.409 35.9824 285.493 36.0914 285 35.9824C284.606 38.5309 282.307 40.1931 278 40.9824L277 39.9824C280.026 39.3449 282 38.179 282 35.9824V29.9824L281 26.9824H285V31.9824C285 33.1897 285.388 33.9824 287 33.9824H289V35.9824ZM284 22.9824C284 23.7075 283.149 24.9824 282 24.9824C280.916 24.9824 281 23.7521 281 22.9824C281 22.2127 280.914 21.9824 282 21.9824C283.086 21.9824 284 22.2145 284 22.9824Z"
        fill="url(#paint16_linear_1541_4010)"
      />
      <path
        d="M309 35.9824H288V33.9824H303C302.193 32.7467 300.447 31.2638 299 29.9824C297.15 28.2971 295.38 27.9824 294 27.9824C292.991 27.9824 293 28.1507 293 28.9824C293 29.3864 292.696 29.3756 293 29.9824L290 30.9824C290.369 28.0376 292.038 25.9824 295 25.9824C297.288 25.9824 299.678 27.0046 302 28.9824C303.784 30.5343 305.025 32.1838 306 33.9824H309V35.9824ZM300 39.9824C300 40.6789 299.178 40.9824 298 40.9824C296.822 40.9824 296 40.7904 296 39.9824C296 39.2403 296.822 37.9824 298 37.9824C299.077 37.9824 300 39.1946 300 39.9824Z"
        fill="url(#paint17_linear_1541_4010)"
      />
      <path
        d="M319 32.9824C319 34.9857 317.011 35.9824 314 35.9824H308V33.9824H313C314.603 33.9824 316 33.1679 316 31.9824V24.9824L315 22.9824L319 21.9824V32.9824Z"
        fill="url(#paint18_linear_1541_4010)"
      />
      <path
        d="M326 21.9868V24.9868V35.9868H322V24.9868V21.9868H326Z"
        fill="url(#paint19_linear_1541_4010)"
      />
      <path
        d="M361 35.9868H332V33.9868H336C335.967 33.8181 336 31.3231 336 25.9868V22.9868H340L339 25.9868V31.9868C339.949 30.8438 342.169 29.9405 344 28.9868C346.256 27.7801 347.909 26.9868 350 26.9868C352.321 26.9868 354.528 27.2879 356 27.9868C357.472 28.6857 358 29.7801 358 30.9868V33.9868H361V35.9868ZM355 33.9868V30.9868C355 29.3773 352.497 28.9868 349 28.9868C347.136 28.9868 345.321 29.546 343 30.9868C341.038 32.1935 339.49 33.0762 339 33.9868H355Z"
        fill="url(#paint20_linear_1541_4010)"
      />
      <path
        d="M379 35.9868H360V33.9868H374C373.202 32.792 372.43 31.2258 371 29.9868C369.171 28.3572 367.365 27.9868 366 27.9868C365.002 27.9868 365 28.1826 365 28.9868C365 29.3774 364.699 30.4 365 30.9868H362C362.365 28.1395 364.071 25.9868 367 25.9868C369.53 25.9868 372.372 27.5301 375 29.9868C377.43 32.2474 378.767 34.2264 379 35.9868ZM370 22.9868C370 23.7044 369.165 24.9868 368 24.9868C366.935 24.9868 366 23.7486 366 22.9868C366 22.225 366.935 21.9868 368 21.9868C369.165 21.9868 370 22.2268 370 22.9868Z"
        fill="url(#paint21_linear_1541_4010)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1541_4010"
        x="0.363193"
        y="0"
        width="95.2736"
        height="79.2736"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.63681" />
        <feGaussianBlur stdDeviation="0.818404" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1541_4010"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1541_4010"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1541_4010"
        x="107.355"
        y="21.9824"
        width="275.29"
        height="37.3246"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.64496" />
        <feGaussianBlur stdDeviation="1.32248" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1541_4010"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1541_4010"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1541_4010"
        x1="97.7726"
        y1="49.7985"
        x2="153.208"
        y2="46.1243"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1541_4010"
        x1="97.6607"
        y1="50.6483"
        x2="153.796"
        y2="46.8653"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1541_4010"
        x1="96.5928"
        y1="51.8035"
        x2="154.845"
        y2="47.689"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1541_4010"
        x1="95.7988"
        y1="52.1954"
        x2="154.629"
        y2="48.0553"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1541_4010"
        x1="96.2696"
        y1="53.6872"
        x2="154.516"
        y2="49.5738"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1541_4010"
        x1="96.3149"
        y1="54.3984"
        x2="154.685"
        y2="50.3237"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1541_4010"
        x1="98.2213"
        y1="55.4638"
        x2="155.128"
        y2="51.5914"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1541_4010"
        x1="95.1665"
        y1="56.3416"
        x2="153.42"
        y2="52.2271"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1541_4010"
        x1="98.3834"
        y1="57.1207"
        x2="155.24"
        y2="53.2558"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1541_4010"
        x1="101.379"
        y1="57.9296"
        x2="156.723"
        y2="54.2684"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1541_4010"
        x1="102.193"
        y1="58.709"
        x2="157.539"
        y2="55.0477"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1541_4010"
        x1="100.115"
        y1="59.5909"
        x2="156.204"
        y2="55.8292"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1541_4010"
        x1="94.2415"
        y1="60.6301"
        x2="152.488"
        y2="56.5166"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1541_4010"
        x1="407.019"
        y1="17.8524"
        x2="341.085"
        y2="22.4579"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1541_4010"
        x1="405.714"
        y1="23.7091"
        x2="340.381"
        y2="28.2284"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1541_4010"
        x1="403.744"
        y1="24.7609"
        x2="339.451"
        y2="29.1315"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_1541_4010"
        x1="406.346"
        y1="22.5539"
        x2="340.835"
        y2="27.0523"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_1541_4010"
        x1="409.296"
        y1="25.5273"
        x2="342.237"
        y2="30.1324"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_1541_4010"
        x1="406.215"
        y1="22.7529"
        x2="340.997"
        y2="27.2986"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_1541_4010"
        x1="404.388"
        y1="23.3223"
        x2="340.618"
        y2="27.6423"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_1541_4010"
        x1="406.311"
        y1="25.6274"
        x2="341.188"
        y2="30.2406"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_1541_4010"
        x1="407.142"
        y1="26.6688"
        x2="340.852"
        y2="31.3239"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#F15A29" />
      </linearGradient>
    </defs>
  </svg>
);

export const personsvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 1.25C9.37665 1.25 7.25 3.37665 7.25 6C7.25 8.62335 9.37665 10.75 12 10.75C14.6234 10.75 16.75 8.62335 16.75 6C16.75 3.37665 14.6234 1.25 12 1.25ZM8.75 6C8.75 4.20507 10.2051 2.75 12 2.75C13.7949 2.75 15.25 4.20507 15.25 6C15.25 7.79493 13.7949 9.25 12 9.25C10.2051 9.25 8.75 7.79493 8.75 6Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 12.25C9.96067 12.25 8.07752 12.7208 6.67815 13.5204C5.3 14.3079 4.25 15.5101 4.25 17C4.25 18.4899 5.3 19.6921 6.67815 20.4796C8.07752 21.2792 9.96067 21.75 12 21.75C14.0393 21.75 15.9225 21.2792 17.3219 20.4796C18.7 19.6921 19.75 18.4899 19.75 17C19.75 15.5101 18.7 14.3079 17.3219 13.5204C15.9225 12.7208 14.0393 12.25 12 12.25ZM5.75 17C5.75 16.2807 6.26701 15.483 7.42236 14.8228C8.55649 14.1747 10.1733 13.75 12 13.75C13.8267 13.75 15.4435 14.1747 16.5776 14.8228C17.733 15.483 18.25 16.2807 18.25 17C18.25 17.7193 17.733 18.517 16.5776 19.1772C15.4435 19.8253 13.8267 20.25 12 20.25C10.1733 20.25 8.55649 19.8253 7.42236 19.1772C6.26701 18.517 5.75 17.7193 5.75 17Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
  </svg>
);

export const currencysvg = (
   <svg
    xmlns="http://www.w3.org/2000/svg"
    id="uae-dirham"
    viewBox="0 0 2042 2042"
    width="24"
    height="24"
  >
    <path
      d="M474.94,1272.7H263.1a39.35,39.35,0,0,1-5-.1c-2.06-.28-3.18-1.34-1.43-3.29,30.93-34.3,40.49-76.77,46.14-120.72a396.09,396.09,0,0,0,2.84-49.77c.1-61.34,0-122.67.21-184,0-6.25-1.5-8.13-7.89-8-17.58.45-35.19.13-52.78.13-40.31,0-67-21-84.8-55.34-12-23.24-12-48.5-11.7-73.76,0-1.12-.22-2.59,1.23-3,1.65-.48,2.5,1,3.48,2,9,8.43,18.42,16.22,30.17,20.64a70.72,70.72,0,0,0,25,4.81c30,0,59.92-.12,89.87.13,5.54.05,7.4-1.3,7.34-7.13q-.42-44.92,0-89.86c.05-5.83-1.42-7.8-7.51-7.67-18.29.38-36.61.14-54.91.13-32.64,0-57-15.23-75-41.5-13.39-19.53-19.37-41.47-19.5-65.07,0-6.42-.17-12.84,0-19.25,0-2.16-1.54-5.44,1.28-6.25,2.06-.59,3.81,2.23,5.45,3.85,15.48,15.3,33.68,23.77,55.86,23.51,29.24-.34,58.49-.18,87.73,0,4.83,0,6.59-1.14,6.57-6.33-.31-65.37.28-130.75-.76-196.11-.71-44.65-8.34-88.23-28-129C271.89,251,265.14,241.34,257.92,232c-.82-1.07-2.76-1.71-2.19-3.26.71-1.91,2.76-1.4,4.39-1.4h8.56c127.91,0,255.82-.3,383.72.28,68.37.31,135.65,9.48,201.41,28.89,68,20.08,130,51.63,183.75,98.14,40.35,34.89,72.29,76.62,97,123.88a480.21,480.21,0,0,1,40.62,108.14c1.17,4.76,3.1,6.55,8.17,6.49,24-.24,48-.09,72,0,40.69.09,67.08,21.68,84.58,56.46,11.39,22.63,11.7,47.07,11.47,71.58,0,1.38.23,3.14-1.37,3.73-1.83.67-3-.82-4.16-2-8.21-8.33-17.39-15.22-28.3-19.73a67.66,67.66,0,0,0-25.65-5.26c-30.67-.12-61.34.08-92-.15-5.55,0-7.34,1.23-7,7.14a652.48,652.48,0,0,1,.07,89.75c-.48,6.85,1.8,7.87,7.79,7.75,17.11-.35,34.27.58,51.34-.24,46.19-2.24,80.8,30.71,93.43,70.73,6,19.15,5.81,38.77,5.64,58.45,0,1.13.51,2.59-1,3-1.92.54-3-1.18-4.15-2.25-8.74-8.43-18-16-29.58-20.36a66.74,66.74,0,0,0-23.55-4.75c-35.9-.07-71.8.06-107.7-.16-5.61,0-8,1.26-9.52,7.3-15.24,62.19-40.35,119.89-79.14,171.26s-87.42,91.1-144.44,120.61c-69.73,36.08-144.55,54.11-222.2,62.14-35,3.62-70.11,4.73-105.28,4.68q-74.9-.09-149.78,0ZM730.42,593.1V593q130.47,0,260.94.14c6.18,0,7.71-1.5,6.56-7.56-10.22-53.87-25.85-105.75-54.15-153.27-29.61-49.73-70.07-87.68-122-113.16C768.42,293,711.22,282.73,652.46,280.59c-60.56-2.22-121.18-.39-181.78-1-6.71-.07-8.21,1.89-8.19,8.33q.3,148.64,0,297.28c0,7,2.24,8.05,8.43,8Q600.66,592.95,730.42,593.1Zm.2,313.92V907q-130.15,0-260.3-.16c-6.38,0-7.83,1.7-7.82,7.93.21,95.32.12,190.63.22,286,0,6.31-2.84,14.49,1.35,18.46s12.26,1.26,18.6,1.17c60.34-.9,120.73,2.48,181-2.27,52-4.1,102.31-14.82,149.78-37,50.4-23.59,91.3-58.27,122.21-104.71,33-49.6,50.79-104.94,62.06-162.82,1.1-5.67-.69-6.6-6.1-6.59Q861.13,907.16,730.62,907Zm5.48-104.68v-.21c88.65,0,177.3-.09,265.95.19,6.38,0,8.23-1.78,8.36-7.71q1-44.91,0-89.8c-.13-5.47-1.76-7.17-7.47-7.16q-265.95.27-531.9,0c-7.12,0-8.6,2.25-8.52,8.88.34,28.75.17,57.51.16,86.26,0,9.54-.05,9.53,9.66,9.53Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
  </svg>
);

export const myplansvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.33333 6.66667C3.33333 5.74619 4.07952 5 5 5H15C15.9205 5 16.6667 5.74619 16.6667 6.66667V13.3333C16.6667 14.2538 15.9205 15 15 15H5C4.07952 15 3.33333 14.2538 3.33333 13.3333V6.66667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M3.33333 6.66667L10 10L16.6667 6.66667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M6.66667 9.16667H13.3333"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M6.66667 11.6667H11.6667"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />

    <path
      d="M14.1667 8.33333L14.5833 9.16667L15.4167 9.16667L14.7917 9.75L15 10.5833L14.1667 10.25L13.3333 10.5833L13.5417 9.75L12.9167 9.16667L13.75 9.16667L14.1667 8.33333Z"
      fill="currentColor"
      fillOpacity="0.8"
    />
  </svg>
)


export const passworlocksvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8 17C8.55229 17 9 16.5523 9 16C9 15.4477 8.55229 15 8 15C7.44772 15 7 15.4477 7 16C7 16.5523 7.44772 17 8 17Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
    <path
      d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
    <path
      d="M17 16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C16.5523 15 17 15.4477 17 16Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.75 8C6.75 5.10051 9.10051 2.75 12 2.75C14.4453 2.75 16.5018 4.42242 17.0846 6.68694C17.1879 7.08808 17.5968 7.32957 17.9979 7.22633C18.3991 7.12308 18.6405 6.7142 18.5373 6.31306C17.788 3.4019 15.1463 1.25 12 1.25C8.27208 1.25 5.25 4.27208 5.25 8V9.30277C5.02317 9.31872 4.80938 9.33948 4.60825 9.36652C3.70814 9.48754 2.95027 9.74643 2.34835 10.3483C1.74643 10.9503 1.48754 11.7081 1.36652 12.6082C1.24996 13.4752 1.24998 14.5775 1.25 15.9451V16.0549C1.24998 17.4225 1.24996 18.5248 1.36652 19.3918C1.48754 20.2919 1.74643 21.0497 2.34835 21.6516C2.95027 22.2536 3.70814 22.5125 4.60825 22.6335C5.47522 22.75 6.57754 22.75 7.94513 22.75H16.0549C17.4225 22.75 18.5248 22.75 19.3918 22.6335C20.2919 22.5125 21.0497 22.2536 21.6517 21.6516C22.2536 21.0497 22.5125 20.2919 22.6335 19.3918C22.75 18.5248 22.75 17.4225 22.75 16.0549V15.9451C22.75 14.5775 22.75 13.4752 22.6335 12.6082C22.5125 11.7081 22.2536 10.9503 21.6517 10.3483C21.0497 9.74643 20.2919 9.48754 19.3918 9.36652C18.5248 9.24996 17.4225 9.24998 16.0549 9.25H7.94513C7.52161 9.24999 7.12353 9.24999 6.75 9.25344V8ZM4.80812 10.8531C4.07435 10.9518 3.68577 11.1322 3.40901 11.409C3.13225 11.6858 2.9518 12.0743 2.85315 12.8081C2.75159 13.5635 2.75 14.5646 2.75 16C2.75 17.4354 2.75159 18.4365 2.85315 19.1919C2.9518 19.9257 3.13225 20.3142 3.40901 20.591C3.68577 20.8678 4.07435 21.0482 4.80812 21.1469C5.56347 21.2484 6.56459 21.25 8 21.25H16C17.4354 21.25 18.4365 21.2484 19.1919 21.1469C19.9257 21.0482 20.3142 20.8678 20.591 20.591C20.8678 20.3142 21.0482 19.9257 21.1469 19.1919C21.2484 18.4365 21.25 17.4354 21.25 16C21.25 14.5646 21.2484 13.5635 21.1469 12.8081C21.0482 12.0743 20.8678 11.6858 20.591 11.409C20.3142 11.1322 19.9257 10.9518 19.1919 10.8531C18.4365 10.7516 17.4354 10.75 16 10.75H8C6.56459 10.75 5.56347 10.7516 4.80812 10.8531Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
  </svg>
);

export const eyelocksvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="12"
    viewBox="0 0 22 12"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.2954 0.310589C21.6761 0.473756 21.8524 0.914665 21.6893 1.29539L20.9999 0.999948C21.6893 1.29539 21.6894 1.29521 21.6893 1.29539L21.6886 1.29707L21.6875 1.29955L21.6843 1.30691L21.6736 1.33099C21.6646 1.35112 21.6518 1.37934 21.6352 1.41502C21.6019 1.48637 21.5533 1.58769 21.4888 1.7141C21.3599 1.96675 21.1675 2.32063 20.9084 2.73641C20.4828 3.41945 19.8724 4.2776 19.0619 5.13013L20.0303 6.09846C20.3231 6.39135 20.3231 6.86622 20.0303 7.15912C19.7374 7.45201 19.2625 7.45201 18.9696 7.15912L17.969 6.15854C17.3093 6.71123 16.5528 7.22998 15.695 7.65618L16.6286 9.09091C16.8545 9.4381 16.7562 9.90268 16.409 10.1286C16.0618 10.3545 15.5972 10.2562 15.3713 9.90899L14.2821 8.2351C13.5028 8.4896 12.659 8.66256 11.7499 8.72457V10.4999C11.7499 10.9142 11.4141 11.2499 10.9999 11.2499C10.5857 11.2499 10.2499 10.9142 10.2499 10.4999V8.72457C9.36889 8.66447 8.54909 8.50016 7.78982 8.25835L6.71575 9.90906C6.48984 10.2562 6.02526 10.3546 5.67807 10.1287C5.33089 9.90275 5.23257 9.43816 5.45847 9.09098L6.37089 7.68872C5.5065 7.2666 4.74381 6.75012 4.07842 6.19821L3.11744 7.15918C2.82455 7.45208 2.34968 7.45208 2.05678 7.15918C1.76389 6.86629 1.76389 6.39142 2.05678 6.09852L2.98055 5.17476C2.15599 4.31507 1.53525 3.4465 1.10277 2.75462C0.839844 2.33398 0.644595 1.97559 0.513882 1.71964C0.448481 1.59157 0.399104 1.48889 0.36537 1.41658C0.3485 1.38042 0.33553 1.35183 0.326415 1.33143L0.315621 1.30704L0.312378 1.29959L0.311293 1.29708L0.310885 1.29613C0.310808 1.29595 0.310565 1.29539 0.999924 0.999948L0.310885 1.29613C0.147718 0.91541 0.323762 0.473756 0.704484 0.310589C1.08489 0.147557 1.52539 0.323496 1.68888 0.703569C1.68882 0.703438 1.68894 0.7037 1.68888 0.703569L1.68983 0.70576L1.69591 0.719474C1.7018 0.732669 1.7114 0.753856 1.72472 0.782427C1.75139 0.839587 1.79296 0.926198 1.84976 1.03742C1.96345 1.26004 2.13762 1.58022 2.37472 1.95955C2.85033 2.72042 3.57157 3.70704 4.55561 4.62154C5.42151 5.42626 6.48259 6.16751 7.75165 6.65576C8.70614 7.02298 9.78537 7.24995 10.9999 7.24995C12.2416 7.24995 13.342 7.01271 14.3124 6.63076C15.5738 6.13427 16.6277 5.3882 17.4866 4.58194C18.4562 3.67191 19.1668 2.69511 19.6354 1.94315C19.869 1.56825 20.0405 1.25221 20.1525 1.03262C20.2085 0.922902 20.2494 0.837517 20.2757 0.781194C20.2888 0.75304 20.2983 0.732174 20.3041 0.719189L20.31 0.705706L20.3106 0.704509C20.3105 0.704607 20.3106 0.704411 20.3106 0.704509M21.2954 0.310589C20.9147 0.147465 20.4738 0.323989 20.3106 0.704509L21.2954 0.310589ZM1.68888 0.703569C1.68882 0.703438 1.68894 0.7037 1.68888 0.703569V0.703569Z"
      fill="currentColor"
      fill-opacity="0.6"
    />
  </svg>
);

export const derhumSign = (
  <svg
    width="30"
    height="26"
    viewBox="0 0 30 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.64542 25.5296C3.48845 24.4729 3.79442 23.3255 3.8172 22.1127C3.84975 20.3578 3.82588 18.6019 3.82588 16.7711C3.47543 16.7711 3.12064 16.7711 2.76586 16.7711C0.981069 16.7711 -0.00843107 15.8008 -0.00192121 14.0586C-0.00192121 13.9374 -0.00192121 13.8161 -0.00192121 13.8108C0.606751 13.9595 1.20457 14.1662 1.81759 14.2369C2.45881 14.3107 3.1163 14.2537 3.81503 14.2537V11.7322C3.39514 11.7322 2.98502 11.7322 2.5749 11.7322C1.05376 11.7322 0.0425629 10.7651 0.00133373 9.26967C-0.00409116 9.06613 0.00133373 8.86259 0.00133373 8.56098C1.19155 9.63457 2.54669 9.03871 3.76512 9.2296C3.81503 9.13363 3.84541 9.10199 3.84541 9.07035C3.80744 7.08664 3.79984 5.10187 3.71196 3.12027C3.66964 2.16585 3.26495 1.29263 2.65193 0.458441C2.85808 0.44684 2.99479 0.432076 3.13149 0.432076C6.31373 0.432076 9.49597 0.415202 12.6782 0.441567C14.5498 0.457386 16.3812 0.749512 18.1508 1.36751C21.8159 2.64675 24.1963 5.10293 25.2618 8.74131C25.3768 9.13468 25.5461 9.24436 25.928 9.21272C26.2686 9.1853 26.6158 9.2296 26.9576 9.20429C28.6437 9.07773 29.5757 10.2663 29.695 11.5835C29.7167 11.8218 29.6983 12.0644 29.6983 12.4082C28.533 11.303 27.1594 11.8883 25.852 11.7005V14.2495C26.2263 14.2495 26.6169 14.278 27.0021 14.2442C28.7022 14.0987 29.6375 15.3769 29.7091 16.7574C29.7189 16.944 29.7102 17.1307 29.7102 17.4123C28.3811 16.2944 26.8773 16.9736 25.4593 16.7247C25.303 17.2109 25.1782 17.6454 25.0253 18.0693C23.7146 21.6929 21.0618 23.9266 17.3013 24.881C15.8116 25.2585 14.2449 25.4695 12.7064 25.5159C9.49055 25.6118 6.27034 25.5486 3.05229 25.5486C2.94705 25.5486 2.84072 25.538 2.64759 25.5285L2.64542 25.5296ZM20.9544 9.18109C20.9544 9.08195 20.9664 9.01129 20.9523 8.94591C20.8785 8.60211 20.8112 8.25725 20.719 7.91872C19.8 4.53766 17.6767 2.32931 14.0366 1.89376C11.9893 1.64909 9.89525 1.76615 7.82185 1.72186C7.811 1.72186 7.79907 1.74611 7.7611 1.78724V9.18109H20.9544ZM20.9848 16.808H7.76543V24.2271C9.49814 24.2271 11.195 24.2683 12.8887 24.2134C14.1223 24.1734 15.3136 23.8601 16.4355 23.3402C19.2575 22.0315 20.4347 19.6512 20.9848 16.808ZM21.2604 11.7607H7.77303V14.2137H21.2604V11.7607Z"
      fill="white"
    />
  </svg>
);
export const derhumOrangeSign = (
  <svg
    width="25"
    height="21"
    viewBox="0 0 25 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.1035 9.97894L23.9211 9.81052C23.6263 9.52982 23.2754 9.38947 22.8965 9.38947H20.9316C20.9597 9.72631 20.9737 10.0632 20.9737 10.4281C20.9737 10.793 20.9597 11.1298 20.9316 11.4807H22.2649C23.2754 11.4807 24.1035 12.4351 24.1035 13.6281V14.1614L23.9211 13.9789C23.6263 13.7123 23.2754 13.5719 22.8965 13.5719H20.6369C19.5561 18.3018 15.7807 20.8702 9.82983 20.8702H2.19475C2.19475 20.8702 3.23335 20.0702 3.23335 17.3895V14.5719H1.95615C0.931594 14.5719 0.103516 13.6035 0.103516 12.4246V10.8912L0.300012 11.0596C0.580713 11.3263 0.931597 11.4807 1.31054 11.4807H3.23335V9.38947H1.95615C0.931594 9.38947 0.103516 8.42105 0.103516 7.2421V5.70877L0.300012 5.89123C0.580713 6.15789 0.931597 6.29824 1.31054 6.29824H3.23335V3.63509C3.23335 0.870176 2.19475 0 2.19475 0H9.82983C15.6123 0 19.486 2.54035 20.6228 7.29824H22.2649C23.2754 7.29824 24.1035 8.25263 24.1035 9.44561V9.97894ZM9.54912 1.0386H7.36317V6.29824H17.0719C16.3421 1.94737 13.8579 1.0386 9.54912 1.0386ZM17.3246 10.4281C17.3246 10.0632 17.3105 9.72631 17.2965 9.38947H7.36317V11.4807H17.2965C17.3105 11.1298 17.3246 10.793 17.3246 10.4281ZM7.36317 19.8175H9.5772C14.1386 19.7053 16.3842 18.5158 17.0719 14.5719H7.36317V16.6947V19.8175Z"
      fill="#E95923"
    />
  </svg>
);
export const carSvg = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        d="M1.25 9.375H18.75"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 14.375V16.25C17.5 16.4158 17.4342 16.5747 17.3169 16.6919C17.1997 16.8092 17.0408 16.875 16.875 16.875H15C14.8342 16.875 14.6753 16.8092 14.5581 16.6919C14.4408 16.5747 14.375 16.4158 14.375 16.25V14.375"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.625 14.375V16.25C5.625 16.4158 5.55915 16.5747 5.44194 16.6919C5.32473 16.8092 5.16576 16.875 5 16.875H3.125C2.95924 16.875 2.80027 16.8092 2.68306 16.6919C2.56585 16.5747 2.5 16.4158 2.5 16.25V14.375"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 11.875H6.25"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.75 11.875H15"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 9.375L15.1641 4.125C15.1156 4.01393 15.0359 3.91935 14.9346 3.85277C14.8334 3.78619 14.7149 3.75049 14.5938 3.75H5.40625C5.28507 3.75049 5.16664 3.78619 5.06538 3.85277C4.96413 3.91935 4.88441 4.01393 4.83594 4.125L2.5 9.375V14.375H17.5V9.375Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export const carSvgDark = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        d="M1.25 9.375H18.75"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 14.375V16.25C17.5 16.4158 17.4342 16.5747 17.3169 16.6919C17.1997 16.8092 17.0408 16.875 16.875 16.875H15C14.8342 16.875 14.6753 16.8092 14.5581 16.6919C14.4408 16.5747 14.375 16.4158 14.375 16.25V14.375"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.625 14.375V16.25C5.625 16.4158 5.55915 16.5747 5.44194 16.6919C5.32473 16.8092 5.16576 16.875 5 16.875H3.125C2.95924 16.875 2.80027 16.8092 2.68306 16.6919C2.56585 16.5747 2.5 16.4158 2.5 16.25V14.375"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 11.875H6.25"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.75 11.875H15"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 9.375L15.1641 4.125C15.1156 4.01393 15.0359 3.91935 14.9346 3.85277C14.8334 3.78619 14.7149 3.75049 14.5938 3.75H5.40625C5.28507 3.75049 5.16664 3.78619 5.06538 3.85277C4.96413 3.91935 4.88441 4.01393 4.83594 4.125L2.5 9.375V14.375H17.5V9.375Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <circle cx="14.5" cy="4.5" r="4.5" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.75 2C15.1642 2 15.5 2.33579 15.5 2.75V4H16.75C17.1642 4 17.5 4.33579 17.5 4.75C17.5 5.16421 17.1642 5.5 16.75 5.5H15.5V6.75C15.5 7.16421 15.1642 7.5 14.75 7.5C14.3358 7.5 14 7.16421 14 6.75V5.5H12.75C12.3358 5.5 12 5.16421 12 4.75C12 4.33579 12.3358 4 12.75 4H14V2.75C14 2.33579 14.3358 2 14.75 2Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
  </svg>
);

export const saleSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.36558 1.33273C7.85387 1.40035 7.22201 1.54549 6.32316 1.75292L5.29967 1.98911C4.54049 2.1643 4.01767 2.28576 3.61834 2.42281C3.23282 2.55512 3.01472 2.68556 2.85014 2.85014C2.68556 3.01472 2.55512 3.23282 2.42281 3.61834C2.28575 4.01767 2.1643 4.54049 1.9891 5.29967L1.75292 6.32316C1.54549 7.22201 1.40035 7.85388 1.33273 8.36558C1.26684 8.86409 1.28203 9.20138 1.36997 9.50801C1.45791 9.81463 1.6238 10.1087 1.94387 10.4965C2.27242 10.8946 2.73039 11.3535 3.38267 12.0058L4.90737 13.5305C6.04027 14.6634 6.84643 15.4677 7.5395 15.9965C8.21814 16.5143 8.71439 16.7087 9.21893 16.7087C9.72346 16.7087 10.2197 16.5143 10.8984 15.9965C11.5914 15.4677 12.3976 14.6634 13.5305 13.5305C14.6634 12.3976 15.4677 11.5914 15.9965 10.8984C16.5143 10.2197 16.7087 9.72346 16.7087 9.21893C16.7087 8.71439 16.5143 8.21814 15.9965 7.5395C15.4677 6.84643 14.6634 6.04027 13.5305 4.90737L12.0058 3.38267C11.3535 2.73039 10.8946 2.27242 10.4965 1.94387C10.1087 1.6238 9.81463 1.45791 9.50801 1.36997C9.20138 1.28203 8.86409 1.26685 8.36558 1.33273ZM8.20181 0.0935001C8.79957 0.0145026 9.32373 0.016732 9.85261 0.168413C10.3815 0.320094 10.8272 0.596006 11.2922 0.979809C11.7417 1.35083 12.2424 1.85148 12.8678 2.47693L14.4477 4.05678C15.5398 5.14895 16.4046 6.01365 16.9902 6.78127C17.5929 7.57111 17.9587 8.3312 17.9587 9.21893C17.9587 10.1067 17.5929 10.8668 16.9902 11.6566C16.4046 12.4242 15.5398 13.2889 14.4477 14.3811L14.3811 14.4477C13.2889 15.5398 12.4242 16.4046 11.6566 16.9902C10.8667 17.5929 10.1067 17.9587 9.21893 17.9587C8.3312 17.9587 7.57111 17.5929 6.78127 16.9902C6.01364 16.4046 5.14893 15.5398 4.05675 14.4476L2.47695 12.8678C1.85149 12.2424 1.35083 11.7417 0.979809 11.2922C0.596006 10.8272 0.320094 10.3815 0.168413 9.85261C0.0167321 9.32373 0.0145026 8.79957 0.0935001 8.20181C0.169867 7.62395 0.32908 6.93405 0.527984 6.07217L0.778536 4.98645C0.944508 4.26718 1.07985 3.68065 1.2405 3.21257C1.40828 2.72371 1.6196 2.31291 1.96626 1.96626C2.31291 1.6196 2.72371 1.40828 3.21256 1.2405C3.68065 1.07985 4.26718 0.944507 4.98645 0.778535L6.07217 0.527984C6.93405 0.329081 7.62395 0.169867 8.20181 0.0935001ZM6.90942 5.66301C6.50263 5.25621 5.84308 5.25621 5.43628 5.66301C5.02949 6.0698 5.02949 6.72935 5.43628 7.13615C5.84308 7.54294 6.50263 7.54294 6.90942 7.13615C7.31622 6.72935 7.31622 6.0698 6.90942 5.66301ZM4.5524 4.77912C5.44735 3.88417 6.89835 3.88417 7.7933 4.77912C8.68826 5.67408 8.68826 7.12508 7.7933 8.02003C6.89835 8.91498 5.44735 8.91498 4.5524 8.02003C3.65745 7.12508 3.65745 5.67408 4.5524 4.77912ZM9.82774 9.08946C9.68033 9.08807 9.48656 9.15423 9.32039 9.32039C8.99745 9.64334 9.08239 9.96627 9.17308 10.057C9.26377 10.1477 9.5867 10.2326 9.90965 9.90965C10.563 9.25628 11.6911 9.03944 12.414 9.76234C12.9748 10.3231 12.97 11.1278 12.6347 11.7655C12.8023 12.009 12.7778 12.3448 12.5613 12.5613C12.3455 12.7771 12.0112 12.8021 11.768 12.6364C11.3873 12.8387 10.9541 12.9145 10.5412 12.8297C10.203 12.7602 9.98528 12.4298 10.0548 12.0917C10.1242 11.7536 10.4547 11.5358 10.7928 11.6053C10.9404 11.6356 11.1784 11.5872 11.3828 11.3828C11.7057 11.0598 11.6208 10.7369 11.5301 10.6462C11.4394 10.5555 11.1165 10.4706 10.7935 10.7935C10.1402 11.4469 9.01209 11.6637 8.2892 10.9408C7.72839 10.38 7.73315 9.57539 8.06852 8.9377C7.90092 8.69423 7.92537 8.35839 8.14188 8.14188C8.3576 7.92616 8.69178 7.9011 8.93503 8.0667C9.21825 7.91618 9.52944 7.83659 9.83953 7.83951C10.1847 7.84277 10.4619 8.12521 10.4586 8.47038C10.4554 8.81554 10.1729 9.09271 9.82774 9.08946Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
  </svg>
);
export const drhumSvgDark = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20 11.694L19.8784 11.581C19.6819 11.3927 19.4479 11.2986 19.1953 11.2986H17.8854C17.9041 11.5245 17.9135 11.7505 17.9135 11.9953C17.9135 12.2401 17.9041 12.466 17.8854 12.7014H18.7743C19.4479 12.7014 20 13.3416 20 14.1419V14.4997L19.8784 14.3773C19.6819 14.1984 19.4479 14.1042 19.1953 14.1042H17.6889C16.9684 17.2771 14.4515 19 10.4842 19H5.39415C5.39415 19 6.08656 18.4633 6.08656 16.6651V14.1042H5.23509C4.55205 14.1042 4 13.4546 4 12.6638V12.306L4.131 12.419C4.31813 12.5978 4.55205 12.7014 4.80469 12.7014H6.08656V11.2986H5.23509C4.55205 11.2986 4 10.649 4 9.8581V9.50034L4.131 9.62273C4.31813 9.80161 4.55205 9.89576 4.80469 9.89576H6.08656V7.43847C6.08656 5.58373 5.39415 5 5.39415 5H10.4842C14.3392 5 16.9216 6.7041 17.6795 9.89576H18.7743C19.4479 9.89576 20 10.536 20 11.3362V11.694ZM10.2971 5.6967H8.1731V9.89576H15.3123C14.8257 6.97714 13.1696 5.6967 10.2971 5.6967ZM15.4807 11.9953C15.4807 11.7505 15.4713 11.5245 15.462 11.2986H8.1731V12.7014H15.462C15.4713 12.466 15.4807 12.2401 15.4807 11.9953ZM8.1731 18.2939H10.3158C13.3567 18.2186 14.8538 16.7498 15.3123 14.1042H8.1731V18.2939Z"
      fill="currentColor"
    />
  </svg>
);
export const paymentSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.91565 0.042026C4.9557 0.0420436 4.99633 0.0420613 5.03757 0.0420613H12.9625C13.0038 0.0420613 13.0444 0.0420436 13.0845 0.042026C13.9318 0.041655 14.5149 0.0413996 15.006 0.21228C15.9334 0.534999 16.6535 1.28138 16.9622 2.22165L16.3684 2.41661L16.9622 2.22165C17.1256 2.71925 17.1254 3.31078 17.1251 4.18911C17.1251 4.22842 17.1251 4.2683 17.1251 4.30878V15.9789C17.1251 17.1999 15.6859 17.9268 14.738 17.0595C14.6718 16.9989 14.5783 16.9989 14.5121 17.0595L14.1095 17.4279C13.336 18.1357 12.1641 18.1357 11.3906 17.4279C11.0948 17.1572 10.6553 17.1572 10.3595 17.4279C9.586 18.1357 8.41412 18.1357 7.64063 17.4279C7.34481 17.1572 6.90531 17.1572 6.60948 17.4279C5.836 18.1357 4.66412 18.1357 3.89063 17.4279L3.48805 17.0595C3.42182 16.9989 3.32829 16.9989 3.26206 17.0595C2.31421 17.9268 0.875056 17.1999 0.875056 15.9789V4.30878C0.875056 4.26831 0.875042 4.22843 0.875027 4.18912C0.874709 3.31078 0.874495 2.71925 1.03787 2.22165C1.34659 1.28138 2.06668 0.534999 2.99415 0.21228C3.48525 0.0413996 4.06836 0.0416549 4.91565 0.042026ZM5.03757 1.29206C4.02 1.29206 3.6695 1.3008 3.40494 1.39285C2.85546 1.58405 2.41599 2.03139 2.2255 2.61158C2.13293 2.89352 2.12506 3.2653 2.12506 4.30878V15.9789C2.12506 16.0781 2.17499 16.1388 2.23764 16.1677C2.27028 16.1828 2.3022 16.1867 2.3288 16.1832C2.35225 16.18 2.38259 16.1699 2.41821 16.1373C2.96211 15.6396 3.78801 15.6396 4.3319 16.1373L4.73448 16.5057C5.03031 16.7764 5.46981 16.7764 5.76563 16.5057C6.53912 15.7979 7.711 15.7979 8.48448 16.5057C8.78031 16.7764 9.21981 16.7764 9.51563 16.5057C10.2891 15.7979 11.461 15.7979 12.2345 16.5057C12.5303 16.7764 12.9698 16.7764 13.2656 16.5057L13.6682 16.1373C14.2121 15.6396 15.038 15.6396 15.5819 16.1373C15.6175 16.1699 15.6479 16.18 15.6713 16.1832C15.6979 16.1867 15.7298 16.1828 15.7625 16.1677C15.8251 16.1388 15.8751 16.0781 15.8751 15.9789V4.30878C15.8751 3.2653 15.8672 2.89352 15.7746 2.61158C15.5841 2.03139 15.1447 1.58405 14.5952 1.39285C14.3306 1.3008 13.9801 1.29206 12.9625 1.29206H5.03757ZM11.4996 5.20085C11.7571 5.43074 11.7795 5.82584 11.5496 6.08332L8.57341 9.41665C8.45483 9.54946 8.28524 9.62539 8.1072 9.62539C7.92916 9.62539 7.75957 9.54946 7.64099 9.41665L6.45051 8.08332C6.22062 7.82584 6.24298 7.43074 6.50046 7.20085C6.75794 6.97096 7.15304 6.99332 7.38293 7.2508L8.1072 8.06198L10.6172 5.2508C10.8471 4.99332 11.2422 4.97096 11.4996 5.20085ZM4.62506 11.9171C4.62506 11.5719 4.90488 11.2921 5.25006 11.2921H12.7501C13.0952 11.2921 13.3751 11.5719 13.3751 11.9171C13.3751 12.2622 13.0952 12.5421 12.7501 12.5421H5.25006C4.90488 12.5421 4.62506 12.2622 4.62506 11.9171Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
  </svg>
);

export const statmentSvg = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.91565 1.04203C5.9557 1.04204 5.99633 1.04206 6.03757 1.04206H13.9625C14.0038 1.04206 14.0444 1.04204 14.0845 1.04203C14.9318 1.04165 15.5149 1.0414 16.006 1.21228C16.9334 1.535 17.6535 2.28138 17.9622 3.22165L17.3684 3.41661L17.9622 3.22165C18.1256 3.71925 18.1254 4.31078 18.1251 5.18911C18.1251 5.22842 18.1251 5.2683 18.1251 5.30878V16.9789C18.1251 18.1999 16.6859 18.9268 15.738 18.0595C15.6718 17.9989 15.5783 17.9989 15.5121 18.0595L15.1095 18.4279C14.336 19.1357 13.1641 19.1357 12.3906 18.4279C12.0948 18.1572 11.6553 18.1572 11.3595 18.4279C10.586 19.1357 9.41412 19.1357 8.64063 18.4279C8.34481 18.1572 7.90531 18.1572 7.60948 18.4279C6.836 19.1357 5.66412 19.1357 4.89063 18.4279L4.48805 18.0595C4.42182 17.9989 4.32829 17.9989 4.26206 18.0595C3.31421 18.9268 1.87506 18.1999 1.87506 16.9789V5.30878C1.87506 5.26831 1.87504 5.22843 1.87503 5.18912C1.87471 4.31078 1.8745 3.71925 2.03787 3.22165C2.34659 2.28138 3.06668 1.535 3.99415 1.21228C4.48525 1.0414 5.06836 1.04165 5.91565 1.04203ZM6.03757 2.29206C5.02 2.29206 4.6695 2.3008 4.40494 2.39285C3.85546 2.58405 3.41599 3.03139 3.2255 3.61158C3.13293 3.89352 3.12506 4.2653 3.12506 5.30878V16.9789C3.12506 17.0781 3.17499 17.1388 3.23764 17.1677C3.27028 17.1828 3.3022 17.1867 3.3288 17.1832C3.35225 17.18 3.38259 17.1699 3.41821 17.1373C3.96211 16.6396 4.78801 16.6396 5.3319 17.1373L5.73448 17.5057C6.03031 17.7764 6.46981 17.7764 6.76563 17.5057C7.53912 16.7979 8.711 16.7979 9.48448 17.5057C9.78031 17.7764 10.2198 17.7764 10.5156 17.5057C11.2891 16.7979 12.461 16.7979 13.2345 17.5057C13.5303 17.7764 13.9698 17.7764 14.2656 17.5057L14.6682 17.1373C15.2121 16.6396 16.038 16.6396 16.5819 17.1373C16.6175 17.1699 16.6479 17.18 16.6713 17.1832C16.6979 17.1867 16.7298 17.1828 16.7625 17.1677C16.8251 17.1388 16.8751 17.0781 16.8751 16.9789V5.30878C16.8751 4.2653 16.8672 3.89352 16.7746 3.61158C16.5841 3.03139 16.1447 2.58405 15.5952 2.39285C15.3306 2.3008 14.9801 2.29206 13.9625 2.29206H6.03757ZM5.20839 6.25039C5.20839 5.90522 5.48821 5.62539 5.83339 5.62539H6.25006C6.59523 5.62539 6.87506 5.90522 6.87506 6.25039C6.87506 6.59557 6.59523 6.87539 6.25006 6.87539H5.83339C5.48821 6.87539 5.20839 6.59557 5.20839 6.25039ZM8.12506 6.25039C8.12506 5.90522 8.40488 5.62539 8.75006 5.62539H14.1667C14.5119 5.62539 14.7917 5.90522 14.7917 6.25039C14.7917 6.59557 14.5119 6.87539 14.1667 6.87539H8.75006C8.40488 6.87539 8.12506 6.59557 8.12506 6.25039ZM5.20839 9.16706C5.20839 8.82188 5.48821 8.54206 5.83339 8.54206H6.25006C6.59523 8.54206 6.87506 8.82188 6.87506 9.16706C6.87506 9.51224 6.59523 9.79206 6.25006 9.79206H5.83339C5.48821 9.79206 5.20839 9.51224 5.20839 9.16706ZM8.12506 9.16706C8.12506 8.82188 8.40488 8.54206 8.75006 8.54206H14.1667C14.5119 8.54206 14.7917 8.82188 14.7917 9.16706C14.7917 9.51224 14.5119 9.79206 14.1667 9.79206H8.75006C8.40488 9.79206 8.12506 9.51224 8.12506 9.16706ZM5.20839 12.0837C5.20839 11.7386 5.48821 11.4587 5.83339 11.4587H6.25006C6.59523 11.4587 6.87506 11.7386 6.87506 12.0837C6.87506 12.4289 6.59523 12.7087 6.25006 12.7087H5.83339C5.48821 12.7087 5.20839 12.4289 5.20839 12.0837ZM8.12506 12.0837C8.12506 11.7386 8.40488 11.4587 8.75006 11.4587H14.1667C14.5119 11.4587 14.7917 11.7386 14.7917 12.0837C14.7917 12.4289 14.5119 12.7087 14.1667 12.7087H8.75006C8.40488 12.7087 8.12506 12.4289 8.12506 12.0837Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
  </svg>
);

export const ticketSvg = (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.0419922 4.8503C0.0419922 2.67455 1.75332 0.875 3.90773 0.875H14.0929C16.2473 0.875 17.9587 2.67455 17.9587 4.8503C17.9587 6.54025 16.9285 8.00035 15.4587 8.57053V12.3767C15.4587 12.6353 15.4587 12.8791 15.4559 13.1079C15.4577 13.1273 15.4587 13.1469 15.4587 13.1667C15.4587 13.1928 15.4571 13.2186 15.4539 13.2439C15.4472 13.6212 15.4311 13.9554 15.3921 14.2454C15.3217 14.7686 15.167 15.2409 14.7874 15.6205C14.4079 16 13.9356 16.1547 13.4124 16.2251C12.9167 16.2917 12.2924 16.2917 11.5437 16.2917H6.457C5.70826 16.2917 5.08391 16.2917 4.58826 16.2251C4.0651 16.1547 3.59276 16 3.21321 15.6205C2.83365 15.2409 2.67892 14.7686 2.60858 14.2454C2.56959 13.9554 2.55342 13.6212 2.54672 13.2439C2.5436 13.2186 2.54199 13.1928 2.54199 13.1667C2.54199 13.1469 2.54291 13.1273 2.54472 13.1079C2.54197 12.8791 2.54198 12.6353 2.54199 12.3767L2.54199 8.57053C1.07211 8.00035 0.0419922 6.54025 0.0419922 4.8503ZM2.542 7.17462C2.54214 6.47691 2.5454 5.89124 2.60858 5.42127C2.67892 4.89811 2.83365 4.42577 3.21321 4.04621C3.59276 3.66666 4.0651 3.51193 4.58826 3.44159C5.08391 3.37495 5.70826 3.37497 6.45699 3.375H11.5437C12.2924 3.37497 12.9167 3.37495 13.4124 3.44159C13.9356 3.51193 14.4079 3.66666 14.7874 4.04621C15.167 4.42577 15.3217 4.89811 15.3921 5.42127C15.4553 5.89124 15.4585 6.47691 15.4587 7.17462C16.2036 6.69832 16.7087 5.84193 16.7087 4.8503C16.7087 3.32541 15.5181 2.125 14.0929 2.125H3.90773C2.48252 2.125 1.29199 3.32541 1.29199 4.8503C1.29199 5.84193 1.79708 6.69832 2.542 7.17462ZM8.37533 4.625H6.50033C5.69698 4.625 5.15735 4.62633 4.75482 4.68045C4.37027 4.73215 4.20569 4.8215 4.09709 4.9301C3.98849 5.03869 3.89914 5.20328 3.84744 5.58783C3.79332 5.99036 3.79199 6.52999 3.79199 7.33333V12.3333C3.79199 12.4048 3.792 12.4743 3.79206 12.5417H14.2086C14.2086 12.4743 14.2087 12.4048 14.2087 12.3333V7.33333C14.2087 6.52999 14.2073 5.99036 14.1532 5.58783C14.1015 5.20328 14.0122 5.03869 13.9036 4.9301C13.795 4.8215 13.6304 4.73215 13.2458 4.68045C12.8433 4.62633 12.3037 4.625 11.5003 4.625H9.62533V8.1438L10.1925 7.48214C10.4171 7.22007 10.8117 7.18971 11.0737 7.41435C11.3358 7.63899 11.3662 8.03355 11.1415 8.29563L9.47486 10.2401C9.35612 10.3786 9.18278 10.4583 9.00033 10.4583C8.81787 10.4583 8.64453 10.3786 8.52579 10.2401L6.85912 8.29563C6.63448 8.03355 6.66484 7.63899 6.92691 7.41435C7.18899 7.18971 7.58356 7.22007 7.80819 7.48214L8.37533 8.1438V4.625ZM14.1818 13.7917H3.81882C3.82617 13.8949 3.83552 13.9902 3.84744 14.0788C3.89914 14.4634 3.98849 14.628 4.09709 14.7366C4.20569 14.8452 4.37027 14.9345 4.75482 14.9862C5.15735 15.0403 5.69698 15.0417 6.50033 15.0417H11.5003C12.3037 15.0417 12.8433 15.0403 13.2458 14.9862C13.6304 14.9345 13.795 14.8452 13.9036 14.7366C14.0122 14.628 14.1015 14.4634 14.1532 14.0788C14.1651 13.9902 14.1745 13.8949 14.1818 13.7917Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
  </svg>
);

export const logOutSvg = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99967 0.708008C8.34485 0.708008 8.62467 0.98783 8.62467 1.33301C8.62467 1.67819 8.34485 1.95801 7.99967 1.95801C4.66295 1.95801 1.95801 4.66295 1.95801 7.99967C1.95801 11.3364 4.66295 14.0413 7.99967 14.0413C8.34485 14.0413 8.62467 14.3212 8.62467 14.6663C8.62467 15.0115 8.34485 15.2913 7.99967 15.2913C3.9726 15.2913 0.708008 12.0268 0.708008 7.99967C0.708008 3.9726 3.9726 0.708008 7.99967 0.708008Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
    <path
      d="M11.7244 5.94162C11.4803 5.69754 11.4803 5.30181 11.7244 5.05773C11.9685 4.81365 12.3642 4.81365 12.6083 5.05773L15.1083 7.55773C15.3524 7.80181 15.3524 8.19754 15.1083 8.44162L12.6083 10.9416C12.3642 11.1857 11.9685 11.1857 11.7244 10.9416C11.4803 10.6975 11.4803 10.3018 11.7244 10.0577L13.1575 8.62467H6.33301C5.98783 8.62467 5.70801 8.34485 5.70801 7.99967C5.70801 7.6545 5.98783 7.37467 6.33301 7.37467H13.1575L11.7244 5.94162Z"
      fill="currentColor"
      fill-opacity="0.8"
    />
  </svg>
);

export const bookMark = (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0855 18C11.7265 18 11.3875 17.9 11.0684 17.7L7.17949 15.24C7.05983 15.16 6.94017 15.16 6.82051 15.24L2.93162 17.7C2.57265 17.94 2.17379 18.03 1.73504 17.97C1.2963 17.91 0.917379 17.74 0.598291 17.46C0.19943 17.1 0 16.64 0 16.08V1.92C0 1.4 0.189459 0.950001 0.568376 0.57C0.947293 0.190001 1.39601 0 1.91453 0H12.0855C12.604 0 13.0527 0.190001 13.4316 0.57C13.8105 0.950001 14 1.4 14 1.92V16.08C14 16.6 13.8105 17.05 13.4316 17.43C13.0527 17.81 12.604 18 12.0855 18ZM7 13.62C7.35897 13.62 7.69801 13.72 8.01709 13.92L11.906 16.38C11.9459 16.42 12.0057 16.44 12.0855 16.44C12.1652 16.44 12.235 16.41 12.2949 16.35C12.3547 16.29 12.3846 16.2 12.3846 16.08V1.92C12.3846 1.8 12.3547 1.71 12.2949 1.65C12.235 1.59 12.1652 1.56 12.0855 1.56H1.91453C1.83476 1.56 1.76496 1.59 1.70513 1.65C1.6453 1.71 1.61538 1.8 1.61538 1.92V16.08C1.61538 16.2 1.66524 16.3 1.76496 16.38C1.86467 16.46 1.97436 16.46 2.09402 16.38L5.98291 13.92C6.30199 13.72 6.64103 13.62 7 13.62Z"
      fill="#888888"
    />
  </svg>
);

export const automationSvg = (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16.5" cy="16.5" r="16" fill="#F15A29" fill-opacity="0.12" />
    <path
      d="M13.1401 12.02C13.1401 12.6385 12.6387 13.14 12.0201 13.14C11.4016 13.14 10.9001 12.6385 10.9001 12.02C10.9001 11.4014 11.4016 10.9 12.0201 10.9C12.6387 10.9 13.1401 11.4014 13.1401 12.02Z"
      stroke="#E95923"
      stroke-width="1.2"
    />
    <path
      d="M13.1403 20.98C13.1403 21.5985 12.6388 22.1 12.0203 22.1C11.4017 22.1 10.9003 21.5985 10.9003 20.98C10.9003 20.3614 11.4017 19.86 12.0203 19.86C12.6388 19.86 13.1403 20.3614 13.1403 20.98Z"
      stroke="#E95923"
      stroke-width="1.2"
    />
    <path
      d="M17.6198 20.98C17.6198 21.5985 17.1184 22.1 16.4998 22.1C15.8813 22.1 15.3798 21.5985 15.3798 20.98C15.3798 20.3614 15.8813 19.86 16.4998 19.86C17.1184 19.86 17.6198 20.3614 17.6198 20.98Z"
      stroke="#E95923"
      stroke-width="1.2"
    />
    <path
      d="M17.6199 12.02C17.6199 12.6385 17.1184 13.14 16.4999 13.14C15.8813 13.14 15.3799 12.6385 15.3799 12.02C15.3799 11.4014 15.8813 10.9 16.4999 10.9C17.1184 10.9 17.6199 11.4014 17.6199 12.02Z"
      stroke="#E95923"
      stroke-width="1.2"
    />
    <path
      d="M22.1001 12.02C22.1001 12.6385 21.5987 13.14 20.9801 13.14C20.3615 13.14 19.8601 12.6385 19.8601 12.02C19.8601 11.4014 20.3615 10.9 20.9801 10.9C21.5987 10.9 22.1001 11.4014 22.1001 12.02Z"
      stroke="#E95923"
      stroke-width="1.2"
    />
    <path
      d="M12.7698 13.14V12.39H11.2698V13.14H12.0198H12.7698ZM11.2698 19.86C11.2698 20.2742 11.6056 20.61 12.0198 20.61C12.434 20.61 12.7698 20.2742 12.7698 19.86H12.0198H11.2698ZM12.0198 13.14H11.2698V19.86H12.0198H12.7698V13.14H12.0198Z"
      fill="#E95923"
    />
    <path
      d="M17.25 13.14V12.39H15.75V13.14H16.5H17.25ZM15.75 19.86C15.75 20.2742 16.0858 20.61 16.5 20.61C16.9142 20.61 17.25 20.2742 17.25 19.86H16.5H15.75ZM16.5 13.14H15.75V19.86H16.5H17.25V13.14H16.5Z"
      fill="#E95923"
    />
    <path
      d="M20.9798 13.14V14.26C20.9798 15.316 20.9798 15.8439 20.6517 16.172C20.3237 16.5 19.7957 16.5 18.7398 16.5H12.0198"
      stroke="#E95923"
      stroke-width="1.5"
      stroke-linecap="square"
    />
    <path
      d="M19.86 18.18V17.58C19.5286 17.58 19.26 17.8486 19.26 18.18H19.86ZM19.26 22.1C19.26 22.4313 19.5286 22.7 19.86 22.7C20.1914 22.7 20.46 22.4313 20.46 22.1H19.86H19.26ZM21.5883 22.4133C21.7613 22.6959 22.1307 22.7847 22.4133 22.6117C22.6959 22.4387 22.7847 22.0693 22.6117 21.7867L22.1 22.1L21.5883 22.4133ZM19.86 18.18V18.78H21.14V18.18V17.58H19.86V18.18ZM19.86 20.14H20.46V18.18H19.86H19.26V20.14H19.86ZM22.1 19.16H21.5C21.5 19.3816 21.3272 19.54 21.14 19.54V20.14V20.74C22.0132 20.74 22.7 20.0209 22.7 19.16H22.1ZM21.14 18.18V18.78C21.3272 18.78 21.5 18.9384 21.5 19.16H22.1H22.7C22.7 18.2991 22.0132 17.58 21.14 17.58V18.18ZM21.14 20.14V19.54H20.9V20.14V20.74H21.14V20.14ZM20.9 20.14V19.54H19.86V20.14V20.74H20.9V20.14ZM20.9 20.14L20.3883 20.4533L21.5883 22.4133L22.1 22.1L22.6117 21.7867L21.4117 19.8267L20.9 20.14ZM19.86 20.14H19.26V22.1H19.86H20.46V20.14H19.86Z"
      fill="#E95923"
    />
  </svg>
);

export const fuelSvg = (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="32"
      height="32"
      rx="16"
      fill="#F15A29"
      fill-opacity="0.12"
    />
    <g clip-path="url(#clip0_2330_664)">
      <path
        d="M12 22V12C12 11.7348 12.1054 11.4804 12.2929 11.2929C12.4804 11.1054 12.7348 11 13 11H18C18.2652 11 18.5196 11.1054 18.7071 11.2929C18.8946 11.4804 19 11.7348 19 12V22"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 22H20.5"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 15.5H20.5C20.7652 15.5 21.0196 15.6054 21.2071 15.7929C21.3946 15.9804 21.5 16.2348 21.5 16.5V19C21.5 19.2652 21.6054 19.5196 21.7929 19.7071C21.9804 19.8946 22.2348 20 22.5 20C22.7652 20 23.0196 19.8946 23.2071 19.7071C23.3946 19.5196 23.5 19.2652 23.5 19V13.9144C23.5 13.783 23.4741 13.6529 23.4238 13.5315C23.3736 13.4101 23.2998 13.2998 23.2069 13.2069L22 12"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 15.5H14"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2330_664">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(8.5 8.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const cylinderSvg = (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="32"
      height="32"
      rx="16"
      fill="#F15A29"
      fill-opacity="0.12"
    />
    <g clip-path="url(#clip0_2330_664)">
      <path
        d="M12 22V12C12 11.7348 12.1054 11.4804 12.2929 11.2929C12.4804 11.1054 12.7348 11 13 11H18C18.2652 11 18.5196 11.1054 18.7071 11.2929C18.8946 11.4804 19 11.7348 19 12V22"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 22H20.5"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 15.5H20.5C20.7652 15.5 21.0196 15.6054 21.2071 15.7929C21.3946 15.9804 21.5 16.2348 21.5 16.5V19C21.5 19.2652 21.6054 19.5196 21.7929 19.7071C21.9804 19.8946 22.2348 20 22.5 20C22.7652 20 23.0196 19.8946 23.2071 19.7071C23.3946 19.5196 23.5 19.2652 23.5 19V13.9144C23.5 13.783 23.4741 13.6529 23.4238 13.5315C23.3736 13.4101 23.2998 13.2998 23.2069 13.2069L22 12"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 15.5H14"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2330_664">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(8.5 8.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const specsSvg = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.83334 5H17.1667V8.33333H3.83334V5Z" fill="#00732F" />
    <path d="M3.83334 8.33337H17.1667V11.6667H3.83334V8.33337Z" fill="white" />
    <path d="M3.83334 11.6666H17.1667V15H3.83334V11.6666Z" fill="currentColor" />
    <path d="M3.83334 5H8.41668V15H3.83334V5Z" fill="#FF0000" />
  </svg>
);

export const engineSvg = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2330_636)">
      <path
        d="M1 7.25V11.25"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.25 2.5H10.25"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 11.5L11.6462 13.8538C11.5526 13.9473 11.4256 13.9999 11.2931 14H6.45687C6.32444 13.9999 6.19745 13.9473 6.10375 13.8538L3.64625 11.3962C3.55266 11.3026 3.50006 11.1756 3.5 11.0431V5.5C3.5 5.36739 3.55268 5.24021 3.64645 5.14645C3.74021 5.05268 3.86739 5 4 5H11.2931C11.4256 5.00006 11.5526 5.05266 11.6462 5.14625L14 7.5H15C15.1326 7.5 15.2598 7.55268 15.3536 7.64645C15.4473 7.74021 15.5 7.86739 15.5 8V11C15.5 11.1326 15.4473 11.2598 15.3536 11.3536C15.2598 11.4473 15.1326 11.5 15 11.5H14Z"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 9.25H3.5"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.25 2.5V5"
        stroke="#E95923"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2330_636">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);